import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector) // Détecte la langue du navigateur
  .use(initReactI18next) // Initialise i18next avec React
  .init({
    resources: {
      fr: {
        translation: {
          menu: {
            open: "MENU",
            close: "FERMER",
            home: "Accueil",
            performanceApp: "Application de performance judo",
            profile: "Profil Utilisateur",
            judokaProfile: "Profil Judoka",
            joinGroup: "Rejoindre un Groupe",
            messages: "Vos Messages",
            messages_form: "Message du Formulaire",
            dashboard: "Tableau de Bord",
            profilutilisateur: "Profil Utilisateur",
            pricing: "Tarifs et Plans",
            results: "Résultats",
            ranking: "Classement",
            grading: "Passage de Grade",
            statistics: "Statistiques",
            techniques: "Techniques",
            quiz: "QCM",
            kata: "Kata",
            lexicon: "Lexique",
            arbitration: "Arbitrage",
            logout: "Déconnexion",
            login: "Connexion",
            register: "Inscription",
            account: "Compte",
            userProfile: "Profil Utilisateur",
            pricingPlans: "Formules & Tarifs",
            agenda: "Agenda",
            yourCompetitions: "Vos Compétitions",
            sharedCompetitions: "Compétitions Partagées",
            performances: "Performances",
            techniquesReview: "Révisions techniques",
            uv2Review: "Révisions UV2",
            katas: "Les Katas",
            techniquesQuiz: "Quizz Techniques",
            refereeing: "Arbitrage",
            refereeingRules: "Règlement d'arbitrage",
            csRules: "Règlement Commissaires Sportifs",
            refereeingQuiz: "Quizz Arbitrage",
            scoreboard: "Tableau de Score",
            yourGroups: "Vos Groupes & Invitations",
            groupResults: "Résultats & Palmarès de vos Judokas",
            groupGrading: "Passage de Grade de vos Judokas",
            groupStatistics: "Statistiques",
          },
          homeHero: {
            performancesTitle: "PERFORMANCES",
            performancesSubtitle:
              "Résultats, Palmarès, Passages de grades, et Statistiques",
            performancesDescription:
              "Suivez vos performances et évaluez vos progrès en compétition.",

            techniquesTitle: "TECHNIQUES",
            techniquesSubtitle: "Révisez vos techniques, UV2, kata, et lexique",
            techniquesDescription:
              "Apprenez et perfectionnez vos techniques grâce à des outils interactifs.",

            agendaTitle: "AGENDA",
            agendaSubtitle: "Compétitions et événements partagés",
            agendaDescription:
              "Organisez et suivez vos compétitions facilement.",

            coachTitle: "COACH",
            coachSubtitle: "Groupes, Statistiques, et Messagerie",
            coachDescription:
              "Gérez vos groupes, consultez leurs résultats, et communiquez avec vos judokas.",

            discover: "Découvrir",
          },
          agenda: {
            title: "Agenda",
            subtitle: "Mes prochaines compétitions & événements",
            notConnectedTitle: "Vos prochains événements",
            notConnectedDescription:
              "Connectez-vous pour découvrir vos prochains événements et compétitions. Si vous n'avez pas encore de compte, commencez par créer un profil pour accéder à toutes ces fonctionnalités.",
            loginOrRegister: "Se connecter ou s'inscrire",
            noEventsTitle: "Aucun événement à venir",
            noEventsDescription:
              "Aucun événement n'est encore planifié. Revenez bientôt pour découvrir vos prochaines compétitions !",
            goToEvents: "Aller à la section des événements",
            myNextEvents: "Mes prochains événements",
            eventDetails: "Voir les détails",
            close: "Fermer",
            seeAllEvents: "Voir tous les événements",
          },
          results: {
            title: "Résultats",
            subtitle: "Mes derniers résultats en compétition",
            notConnectedTitle: "Vos résultats de compétitions",
            notConnectedDescription:
              "Connectez-vous pour découvrir vos derniers résultats, classements, observations et bien plus encore. Si vous n'avez pas encore de compte, commencez par créer un profil pour accéder à toutes ces fonctionnalités.",
            loginOrRegister: "Se connecter ou s'inscrire",
            noResultsTitle: "Aucun résultat disponible",
            noResultsDescription:
              "Vous pouvez dès à présent enregistrer vos résultats sur vos compétitions afin de les consulter ici plus facilement.",
            goToResults: "Aller vers la section des résultats",
            table: {
              date: "Date",
              title: "Titre",
              ranking: "Classement",
              results: "Résultats",
              observations: "Observations",
            },
            seeAllResults: "Afficher tous mes résultats",
          },
          palmares: {
            title: "Palmarès",
            subtitle: "Mes derniers palmarès",
            notConnectedTitle: "Vos derniers palmarès",
            notConnectedDescription:
              "Connectez-vous pour enregistrer et découvrir vos dernières performances en compétition. Accédez à votre palmarès et partagez vos réussites !",
            loginOrRegister: "Se connecter ou s'inscrire",
            noPalmaresTitle: "Aucun palmarès disponible",
            noPalmaresDescription:
              "Vous n'avez pas encore de résultats enregistrés dans votre palmarès. Participez à des compétitions et enregistrez vos performances !",
            goToPalmares: "Accéder à la section Palmarès",
            seeAllPalmares: "Voir le Palmarès",
          },
          passageGrade: {
            title: "Passages de Grades",
            subtitle: "Mes derniers passages de grades",
            notConnectedTitle: "Vos passages de grades",
            notConnectedDescription:
              "Connectez-vous pour consulter vos derniers passages de grades et suivre votre progression.",
            loginOrRegister: "Se connecter ou s'inscrire",
            noGradesTitle: "Aucun passage de grade enregistré",
            noGradesDescription:
              "Vous n'avez pas encore enregistré vos passages de grades. Commencez dès maintenant pour suivre votre progression !",
            goToGrades: "Accéder à la section",
            seeAllGrades: "Afficher tous mes passages de grade",
            gradeDate: "Date de passage",
            preparationGrade: "Préparation Grade",
            dominante: "Dominante",
            uv1: "UV1",
            uv2: "UV2",
            uv3Points: "Points UV3",
            uv4: "UV4",
            observations: "Observations",
            validated: "Validé",
            notValidated: "Non validé",
            noNextBelt: "Aucune ceinture suivante définie.",
          },
          techniquesFavorites: {
            title: "Tokui Waza",
            subtitle: "Mes techniques favorites",
            notConnectedTitle: "Vos techniques favorites",
            notConnectedDescription:
              "Connectez-vous pour consulter vos techniques préférées et découvrir de nouvelles inspirations pour votre pratique du judo.",
            loginOrRegister: "Se connecter ou s'inscrire",
            noTechniquesTitle: "Aucune technique favorite enregistrée",
            noTechniquesDescription:
              "Vous n'avez pas encore sélectionné vos techniques favorites. Explorez les techniques de judo et ajoutez celles qui vous inspirent !",
            exploreTechniques: "Explorer les techniques",
            seeAllTechniques: "Voir toutes les techniques",
            family: "Famille",
          },
          diaporama: {
            introduction:
              "Voici une sélection de quelques pages de l'application.",
            menu: {
              alt: "Menu",
              caption: "Menu de l'Application",
            },
            formules: {
              alt: "Formules",
              caption: "Formules gratuites et payantes",
            },
            evenements: {
              alt: "Evénements",
              caption: "Consulter ses prochaines compétitions ou échéances",
            },
            evenementsPartages: {
              alt: "Evénements partagés",
              caption:
                "Possibilité de consulter les événements partagés par d'autres utilisateurs et de les copier dans son agenda",
            },
            selectionDept: {
              alt: "Sélection par département",
              caption: "Tri par département sur une carte interactive",
            },
            resultats: {
              alt: "Résultats",
              caption: "Enregistrement de ses résultats sur les événements",
            },
            palmares: {
              alt: "Palmarès",
              caption: "Ajout des résultats sur son palmarès",
            },
            passages: {
              alt: "Passage de grades",
              caption: "Gestion des passages de grades & UV",
            },
            stats: {
              alt: "Statistiques",
              caption: "Page de statistiques de ses combats",
            },
            techniques: {
              alt: "Techniques",
              caption: "Révision des techniques de Judo et Ju-Jitsu",
            },
            kata: {
              alt: "Kata",
              caption: "Révision des kata",
            },
            quizz: {
              alt: "Quizz",
              caption: "Quizz Techniques",
            },
            lexique: {
              alt: "Lexique",
              caption: "Lexique Japonais-Français",
            },
            arbitrage: {
              alt: "Arbitrage",
              caption: "Règlement d'arbitrage et commissaire sportif",
            },
            gestionGroupes: {
              alt: "Coach - Gestion des groupes et judokas",
              caption: "Gestion des groupes et des judokas pour les coachs",
            },
            qrCode: {
              alt: "Invitatiton par QR code",
              caption: "Invitation par QR code pour rejoindre un groupe",
            },
            enregistrementResultats: {
              alt: "Enregistrement des résultats",
              caption: "Enregistrement des résultats des judokas",
            },
            passagesGrades: {
              alt: "Enregistrement des passages de grades",
              caption: "Enregistrement des passages de grade des judokas",
            },
          },
          formContact: {
            title: "Formulaire de Contact",
            intro: "Vous avez des questions ou des commentaires ?",
            prompt: "N'hésitez pas à nous contacter.",
            email: "Votre email",
            name: "Nom Prénom",
            message: "Votre Message",
            sendButton: "Envoyer",
            hoverLabel: "Envoyer le message",
            successMessage: "Votre message a bien été envoyé!",
          },
          profile: {
            title: "Profil Utilisateur",
            changePhoto: "Modifier la photo",
            chosenPlan: "Formule choisie",
            editInfo: "Modifier les informations",
            selectAvatar: "Sélectionner un Avatar",
            editProfile: "Modifier le Profil",
            lastName: "Nom",
            firstName: "Prénom",
            cancel: "Annuler",
            save: "Sauvegarder",
            close: "Fermer",
          },
          judokaProfile: {
            title: "Profil Judoka",
            changePhoto: "Modifier la photo",
            birthDate: "Date de naissance",
            weight: "Poids",
            license: "Licence",
            club: "Club",
            country: "Pays",
            region: "Département / Province",
            notSpecified: "Non spécifié",
            editInfo: "Modifier les informations",
            selectAvatar: "Sélectionner un Avatar",
            editProfile: "Modifier le Profil Judoka(te)",
            createProfile: "Créer un Profil Judoka(te)",
            lastName: "Nom",
            firstName: "Prénom",
            gender: "Genre",
            selectGender: "Sélectionnez le genre",
            male: "Masculin",
            female: "Féminin",
            cancel: "Annuler",
            save: "Sauvegarder",
          },
          judokaCategory: {
            title: "Catégories du Judoka",
            age: "Âge",
            years: "ans",
            notDefined: "Non défini",
            ageCategory: "Catégorie d'âge",
            weightCategory: "Catégorie de poids",
          },
          joinGroup: {
            title: "Rejoindre un groupe",
            description:
              "Scannez un QR Code ou saisissez un lien d'invitation pour rejoindre un groupe.",
            noRequests: "Vous n'avez pas de demande en cours.",
            pendingRequest:
              "Votre demande pour rejoindre le groupe est en attente de validation par le coach.",
            approvedRequest: "Vous êtes inscrit dans le groupe.",
            rejectedRequest:
              "Votre demande pour rejoindre le groupe a été refusée par le coach.",
            leaveGroup: "Quitter le Groupe",
            scanQr: "Scanner un QR Code",
            scannedQr: "QR Code Scanné :",
            invalidQr: "Aucun contenu valide trouvé dans le QR Code.",
            enterInviteLink: "Saisissez un lien d'invitation :",
            linkPlaceholder: "https://www.judo-coach-pro.com/join-group/...",
            submit: "Soumettre",
            nocamera:
              "Si la caméra ne fonctionne pas, saisissez directement le lien d'invitation envoyé par votre coach.",
          },
          messagerie: {
            home: "Accueil",
            yourcount: "Votre Compte",
            messagerie: "Messagerie",
            messagerieTitle: "Vos Messages",
            sendAdminMessage: "Envoyer un message à l'administrateur",
            sendJudokaMessage: "Envoyer un message à vos judokas",
            sendCoachMessage: "Envoyer un message à votre coach",
            receivedMessages: "Messages reçus",
            loading: "Chargement des messages...",
            noReadMessage: "Marquer comme non lu",
            readMessage: "Marquer comme lu",
            answer: "Répondre",
            delete: "Supprimer",
            noMessages: "Aucun message à afficher.",
            adminMessage: "Message pour l'administrateur",
            btnAnnuler: "Annuler",
            btnEnvoyer: "Envoyer",
            responseMessage: "Répondre au message",
          },
          pricing: {
            title: "Nos Formules",
            subtitle: "Choisissez une formule adaptée à vos besoins.",
            unauthenticated_user: "Utilisateur non identifié",
            judo_expert: {
              name: "Judo Expert",
              price: "Gratuit",
              features: [
                "Résultats, palmarès, passage de grades et statistiques",
                "Accès aux compétitions et événements partagés",
                "Techniques, UV2, kata, Quizz, Lexique",
                "Règlement, Quizz arbitrage, Tableau de score",
              ],
            },
            coach: {
              name: "Coach",
              price: "10 €",
              features: [
                "Judo Expert plus ...",
                "Gestion d'un groupe jusqu'à 10 adhérents",
                "Messagerie privée et sécurisée avec vos adhérents",
                "Invitation et réception des réponses à vos événements",
                "Résultats, Palmarès et Statistiques de vos adhérents",
              ],
            },
            coach_pro: {
              name: "Coach Pro",
              price: "20 €",
              features: [
                "Judo Coach plus ...",
                "Gestion de 5 groupes, jusqu'à 50 adhérents",
              ],
            },
            coach_ultim: {
              name: "Coach Ultim",
              price: "30 €",
              features: [
                "Judo Coach Pro plus ...",
                "Gestion de 10 groupes, plus de 50 adhérents",
              ],
            },
            notifications: {
              success:
                "Transaction réussie ! Cliquez sur 'Rafraîchir la Formule' pour mettre à jour.",
              cancel: "Transaction annulée.",
            },
            errors: {
              user_corrupted:
                "Vos informations utilisateur semblent corrompues. Veuillez vous reconnecter.",
            },
            soutien: {
              title:
                "💙 Soutenez Judo Coach Pro et contribuez à son évolution 💙",
              description_1:
                "L'application Judo Coach Pro est une application web gratuite pour les judokas, installable sur tous les types d'appareils (Android, iOS, tablettes, PC). Si vous pensez que cette application peut vous aider dans votre pratique du judo, vous pouvez faire un don.",
              description_2:
                "Votre générosité m'aidera à développer de nouvelles fonctionnalités et à créer de nouvelles applications en lien avec le Judo. Merci par avance. 🙏",
              button: "Faire un don de 5 €",
            },
          },
        },
      },
      en: {
        translation: {
          menu: {
            open: "MENU",
            close: "CLOSED",
            home: "Home",
            performanceApp: "Judo Performance App",
            profile: "User Profile",
            judokaProfile: "Judoka Profile",
            joinGroup: "Join a Group",
            messages: "Messages",
            messages_form: "Message Form",
            dashboard: "Dashboard",
            profilutilisateur: "User Profile",
            pricing: "Pricing & Plans",
            results: "Results",
            ranking: "Ranking",
            grading: "Belt Promotion",
            statistics: "Statistics",
            techniques: "Techniques",
            quiz: "Quiz",
            kata: "Kata",
            lexicon: "Lexicon",
            arbitration: "Refereeing",
            logout: "Logout",
            login: "Login",
            register: "Register",
            account: "Account",
            userProfile: "User Profile",
            pricingPlans: "Pricing & Plans",
            agenda: "Agenda",
            yourCompetitions: "Your Competitions",
            sharedCompetitions: "Shared Competitions",
            performances: "Performances",
            techniquesReview: "Techniques Review",
            uv2Review: "UV2 Review",
            katas: "Katas",
            techniquesQuiz: "Techniques Quiz",
            refereeing: "Refereeing",
            refereeingRules: "Refereeing Rules",
            csRules: "CS Rules",
            refereeingQuiz: "Refereeing Quiz",
            scoreboard: "Scoreboard",
            yourGroups: "Your Groups & Invitations",
            groupResults: "Results & Achievements of your Judokas",
            groupGrading: "Belt Promotion of your Judokas",
            groupStatistics: "Statistics",
          },
          homeHero: {
            performancesTitle: "PERFORMANCES",
            performancesSubtitle:
              "Results, Rankings, Belt Promotions, and Statistics",
            performancesDescription:
              "Track your performances and assess your progress in competitions.",

            techniquesTitle: "TECHNIQUES",
            techniquesSubtitle:
              "Review your techniques, UV2, kata, and lexicon",
            techniquesDescription:
              "Learn and refine your techniques with interactive tools.",

            agendaTitle: "AGENDA",
            agendaSubtitle: "Competitions and shared events",
            agendaDescription: "Organize and follow your competitions easily.",

            coachTitle: "COACH",
            coachSubtitle: "Groups, Statistics, and Messaging",
            coachDescription:
              "Manage your groups, check their results, and communicate with your judokas.",

            discover: "Discover",
          },
          agenda: {
            title: "Agenda",
            subtitle: "My upcoming competitions & events",
            notConnectedTitle: "Your upcoming events",
            notConnectedDescription:
              "Log in to see your upcoming events and competitions. If you don't have an account yet, start by creating a profile to access all these features.",
            loginOrRegister: "Log in or Register",
            noEventsTitle: "No upcoming events",
            noEventsDescription:
              "No events are scheduled yet. Check back soon to see your upcoming competitions!",
            goToEvents: "Go to the events section",
            myNextEvents: "My upcoming events",
            eventDetails: "See details",
            close: "Close",
            seeAllEvents: "See all events",
          },
          results: {
            title: "Results",
            subtitle: "My latest competition results",
            notConnectedTitle: "Your competition results",
            notConnectedDescription:
              "Log in to see your latest results, rankings, observations, and more. If you don't have an account yet, start by creating a profile to access all these features.",
            loginOrRegister: "Log in or Register",
            noResultsTitle: "No results available",
            noResultsDescription:
              "You can now record your competition results to easily view them here.",
            goToResults: "Go to the results section",
            table: {
              date: "Date",
              title: "Title",
              ranking: "Ranking",
              results: "Results",
              observations: "Observations",
            },
            seeAllResults: "Show all my results",
          },
          palmares: {
            title: "Rankings",
            subtitle: "My latest rankings",
            notConnectedTitle: "Your latest rankings",
            notConnectedDescription:
              "Log in to record and discover your latest competition performances. Access your rankings and share your achievements!",
            loginOrRegister: "Log in or Register",
            noPalmaresTitle: "No rankings available",
            noPalmaresDescription:
              "You don't have any recorded results in your rankings yet. Participate in competitions and track your achievements!",
            goToPalmares: "Go to the Rankings section",
            seeAllPalmares: "View Rankings",
          },
          passageGrade: {
            title: "Belt Promotions",
            subtitle: "My latest belt promotions",
            notConnectedTitle: "Your belt promotions",
            notConnectedDescription:
              "Log in to view your latest belt promotions and track your progress.",
            loginOrRegister: "Log in or Register",
            noGradesTitle: "No belt promotion recorded",
            noGradesDescription:
              "You haven't recorded any belt promotions yet. Start now to track your progress!",
            goToGrades: "Go to the section",
            seeAllGrades: "Show all my belt promotions",
            gradeDate: "Promotion date",
            preparationGrade: "Grade Preparation",
            dominante: "Main Focus",
            uv1: "UV1",
            uv2: "UV2",
            uv3Points: "UV3 Points",
            uv4: "UV4",
            observations: "Observations",
            validated: "Validated",
            notValidated: "Not Validated",
            noNextBelt: "No next belt defined.",
          },
          techniquesFavorites: {
            title: "Tokui Waza",
            subtitle: "My Favorite Techniques",
            notConnectedTitle: "Your Favorite Techniques",
            notConnectedDescription:
              "Log in to view your favorite techniques and discover new inspirations for your judo practice.",
            loginOrRegister: "Log in or register",
            noTechniquesTitle: "No Favorite Techniques Saved",
            noTechniquesDescription:
              "You haven't selected any favorite techniques yet. Explore judo techniques and add your favorites!",
            exploreTechniques: "Explore Techniques",
            seeAllTechniques: "View All Techniques",
            family: "Family",
          },
          diaporama: {
            introduction:
              "Here is a selection of some pages of the application.",
            menu: {
              alt: "Menu",
              caption: "Application Menu",
            },
            formules: {
              alt: "Plans",
              caption: "Free and paid plans",
            },
            evenements: {
              alt: "Events",
              caption: "Check your upcoming competitions or deadlines",
            },
            evenementsPartages: {
              alt: "Shared Events",
              caption:
                "Possibility to consult events shared by other users and copy them to your calendar",
            },
            selectionDept: {
              alt: "Selection by department",
              caption: "Sorting by department on an interactive map",
            },
            resultats: {
              alt: "Results",
              caption: "Recording your results on events",
            },
            palmares: {
              alt: "Rankings",
              caption: "Adding results to your rankings",
            },
            passages: {
              alt: "Belt Promotions",
              caption: "Managing belt promotions & UV",
            },
            stats: {
              alt: "Statistics",
              caption: "Statistics page of your fights",
            },
            techniques: {
              alt: "Techniques",
              caption: "Review of Judo and Ju-Jitsu techniques",
            },
            kata: {
              alt: "Kata",
              caption: "Review of the katas",
            },
            quizz: {
              alt: "Quiz",
              caption: "Techniques Quiz",
            },
            lexique: {
              alt: "Lexicon",
              caption: "Japanese-French Lexicon",
            },
            arbitrage: {
              alt: "Refereeing",
              caption: "Refereeing regulations and sports commissioner",
            },
            gestionGroupes: {
              alt: "Coach - Group and judokas management",
              caption: "Group and judokas management for coaches",
            },
            qrCode: {
              alt: "QR code invitation",
              caption: "Invitation by QR code to join a group",
            },
            enregistrementResultats: {
              alt: "Recording results",
              caption: "Recording judokas' results",
            },
            passagesGrades: {
              alt: "Recording belt promotions",
              caption: "Recording judokas' belt promotions",
            },
          },
          formContact: {
            title: "Contact Form",
            intro: "Do you have any questions or comments?",
            prompt: "Feel free to contact us.",
            email: "Your email",
            name: "Full Name",
            message: "Your Message",
            sendButton: "Send",
            hoverLabel: "Send the message",
            successMessage: "Your message has been successfully sent!",
          },
          profile: {
            title: "User Profile",
            changePhoto: "Change Photo",
            chosenPlan: "Chosen Plan",
            editInfo: "Edit Information",
            selectAvatar: "Select an Avatar",
            editProfile: "Edit Profile",
            lastName: "Last Name",
            firstName: "First Name",
            cancel: "Cancel",
            save: "Save",
            close: "Close",
          },
          judokaProfile: {
            title: "Judoka Profile",
            changePhoto: "Change Photo",
            birthDate: "Date of Birth",
            weight: "Weight",
            license: "License",
            club: "Club",
            country: "Country",
            region: "Region / Province",
            notSpecified: "Not specified",
            editInfo: "Edit Information",
            selectAvatar: "Select an Avatar",
            editProfile: "Edit Judoka Profile",
            createProfile: "Create a Judoka Profile",
            lastName: "Last Name",
            firstName: "First Name",
            gender: "Gender",
            selectGender: "Select Gender",
            male: "Male",
            female: "Female",
            cancel: "Cancel",
            save: "Save",
          },
          judokaCategory: {
            title: "Judoka Categories",
            age: "Age",
            years: "years",
            notDefined: "Not defined",
            ageCategory: "Age Category",
            weightCategory: "Weight Category",
          },
          joinGroup: {
            title: "Join a Group",
            description:
              "Scan a QR Code or enter an invitation link to join a group.",
            noRequests: "You have no pending requests.",
            pendingRequest:
              "Your request to join the group is awaiting coach approval.",
            approvedRequest: "You are now a member of the group.",
            rejectedRequest:
              "Your request to join the group was rejected by the coach.",
            leaveGroup: "Leave Group",
            scanQr: "Scan a QR Code",
            scannedQr: "Scanned QR Code:",
            invalidQr: "No valid content found in the QR Code.",
            enterInviteLink: "Enter an invitation link:",
            linkPlaceholder: "https://www.judo-coach-pro.com/join-group/...",
            submit: "Submit",
            nocamera:
              "If the camera is not working, enter the invitation link sent by your coach directly.",
          },
          messagerie: {
            home: "Home",
            yourcount: "Your Account",
            messagerie: "Messaging",
            messagerieTitle: "Your Messages",
            sendAdminMessage: "Send a message to the administrator",
            sendJudokaMessage: "Send a message to your judokas",
            sendCoachMessage: "Send a message to your coach",
            receivedMessages: "Received Messages",
            loading: "Loading messages...",
            noReadMessage: "Mark as unread",
            readMessage: "Mark as read",
            answer: "Reply",
            delete: "Delete",
            noMessages: "No messages to display.",
            adminMessage: "Message for the administrator",
            btnAnnuler: "Cancel",
            btnEnvoyer: "Send",
            responseMessage: "Reply to the message",
          },
          pricing: {
            title: "Our Plans",
            subtitle: "Choose a plan that fits your needs.",
            unauthenticated_user: "Unauthenticated user",
            judo_expert: {
              name: "Judo Expert",
              price: "Free",
              features: [
                "Results, rankings, belt grading, and statistics",
                "Access to shared competitions and events",
                "Techniques, UV2, kata, Quizzes, Glossary",
                "Regulations, Referee Quiz, Scoreboard",
              ],
            },
            coach: {
              name: "Coach",
              price: "10 €",
              features: [
                "Judo Expert plus ...",
                "Manage a group of up to 10 members",
                "Private and secure messaging with your members",
                "Invite and receive responses for your events",
                "Results, Rankings, and Statistics of your members",
              ],
            },
            coach_pro: {
              name: "Coach Pro",
              price: "20 €",
              features: [
                "Judo Coach plus ...",
                "Manage 5 groups, up to 50 members",
              ],
            },
            coach_ultim: {
              name: "Coach Ultim",
              price: "30 €",
              features: [
                "Judo Coach Pro plus ...",
                "Manage 10 groups, more than 50 members",
              ],
            },
            notifications: {
              success:
                "Transaction successful! Click 'Refresh Plan' to update.",
              cancel: "Transaction canceled.",
            },
            errors: {
              user_corrupted:
                "Your user information seems corrupted. Please log in again.",
            },
            soutien: {
              title:
                "💙 Support Judo Coach Pro and contribute to its growth 💙",
              description_1:
                "The Judo Coach Pro application is a free web app for judokas, installable on all types of devices (Android, iOS, tablets, PC). If you think this app can help in your judo practice, you can make a donation.",
              description_2:
                "Your generosity will help me develop new features and create new applications related to Judo. Thank you in advance. 🙏",
              button: "Donate 5 €",
            },
          },
        },
      },
      es: {
        translation: {
          menu: {
            open: "MENÚ",
            close: "CERRAR",
            home: "Inicio",
            performanceApp: "Aplicación de Rendimiento de Judo",
            profile: "Perfil de Usuario",
            judokaProfile: "Perfil de Judoka",
            joinGroup: "Unirse a un Grupo",
            messages: "Mensajes",
            messages_form: "Mensaje del Formulario",
            dashboard: "Tablero de Control",
            profilutilisateur: "Perfil de Usuario",
            pricing: "Planes y Tarifas",
            results: "Resultados",
            ranking: "Clasificación",
            grading: "Ascenso de Cinturón",
            statistics: "Estadísticas",
            techniques: "Técnicas",
            quiz: "Cuestionario",
            kata: "Kata",
            lexicon: "Léxico",
            arbitration: "Arbitraje",
            logout: "Cerrar sesión",
            login: "Iniciar sesión",
            register: "Registrarse",
            account: "Cuenta",
            userProfile: "Perfil de Usuario",
            pricingPlans: "Planes y Tarifas",
            agenda: "Agenda",
            yourCompetitions: "Tus Competiciones",
            sharedCompetitions: "Competiciones Compartidas",
            performances: "Actuaciones",
            techniquesReview: "Revisión de Técnicas",
            uv2Review: "Revisión UV2",
            katas: "Katas",
            techniquesQuiz: "Cuestionario de Técnicas",
            refereeing: "Arbitraje",
            refereeingRules: "Reglas de Arbitraje",
            csRules: "Reglas de CS",
            refereeingQuiz: "Cuestionario de Arbitraje",
            scoreboard: "Marcador",
            yourGroups: "Tus Grupos e Invitaciones",
            groupResults: "Resultados y Logros de tus Judokas",
            groupGrading: "Ascenso de Cinturón de tus Judokas",
            groupStatistics: "Estadísticas",
          },
          homeHero: {
            performancesTitle: "ACTUACIONES",
            performancesSubtitle:
              "Resultados, Clasificaciones, Ascensos de Cinturón y Estadísticas",
            performancesDescription:
              "Siga sus actuaciones y evalúe su progreso en competiciones.",

            techniquesTitle: "TÉCNICAS",
            techniquesSubtitle: "Revise sus técnicas, UV2, kata y léxico",
            techniquesDescription:
              "Aprenda y perfeccione sus técnicas con herramientas interactivas.",

            agendaTitle: "AGENDA",
            agendaSubtitle: "Competiciones y eventos compartidos",
            agendaDescription: "Organice y siga fácilmente sus competiciones.",

            coachTitle: "ENTRENADOR",
            coachSubtitle: "Grupos, Estadísticas y Mensajería",
            coachDescription:
              "Administre sus grupos, consulte sus resultados y comunique con sus judokas.",

            discover: "Descubrir",
          },
          agenda: {
            title: "Agenda",
            subtitle: "Mis próximas competiciones y eventos",
            notConnectedTitle: "Tus próximos eventos",
            notConnectedDescription:
              "Inicie sesión para ver sus próximos eventos y competiciones. Si aún no tiene una cuenta, comience creando un perfil para acceder a todas estas funciones.",
            loginOrRegister: "Iniciar sesión o Registrarse",
            noEventsTitle: "No hay eventos próximos",
            noEventsDescription:
              "Aún no se han programado eventos. ¡Vuelve pronto para ver tus próximas competiciones!",
            goToEvents: "Ir a la sección de eventos",
            myNextEvents: "Mis próximos eventos",
            eventDetails: "Ver detalles",
            close: "Cerrar",
            seeAllEvents: "Ver todos los eventos",
          },
          results: {
            title: "Resultados",
            subtitle: "Mis últimos resultados en competición",
            notConnectedTitle: "Tus resultados de competición",
            notConnectedDescription:
              "Inicie sesión para ver sus últimos resultados, clasificaciones, observaciones y más. Si aún no tiene una cuenta, comience creando un perfil para acceder a todas estas funciones.",
            loginOrRegister: "Iniciar sesión o Registrarse",
            noResultsTitle: "No hay resultados disponibles",
            noResultsDescription:
              "Ya puede registrar sus resultados en competiciones para verlos fácilmente aquí.",
            goToResults: "Ir a la sección de resultados",
            table: {
              date: "Fecha",
              title: "Título",
              ranking: "Clasificación",
              results: "Resultados",
              observations: "Observaciones",
            },
            seeAllResults: "Mostrar todos mis resultados",
          },
          palmares: {
            title: "Clasificaciones",
            subtitle: "Mis últimas clasificaciones",
            notConnectedTitle: "Tus últimas clasificaciones",
            notConnectedDescription:
              "Inicie sesión para registrar y descubrir sus últimas actuaciones en competición. ¡Acceda a sus clasificaciones y comparta sus logros!",
            loginOrRegister: "Iniciar sesión o Registrarse",
            noPalmaresTitle: "No hay clasificaciones disponibles",
            noPalmaresDescription:
              "Aún no tiene resultados registrados en sus clasificaciones. ¡Participe en competiciones y haga un seguimiento de sus logros!",
            goToPalmares: "Ir a la sección de Clasificaciones",
            seeAllPalmares: "Ver Clasificaciones",
          },
          passageGrade: {
            title: "Ascensos de Cinturón",
            subtitle: "Mis últimos ascensos de cinturón",
            notConnectedTitle: "Tus ascensos de cinturón",
            notConnectedDescription:
              "Inicie sesión para ver sus últimos ascensos de cinturón y hacer un seguimiento de su progreso.",
            loginOrRegister: "Iniciar sesión o Registrarse",
            noGradesTitle: "No hay ascenso de cinturón registrado",
            noGradesDescription:
              "Aún no ha registrado ningún ascenso de cinturón. ¡Comience ahora para hacer un seguimiento de su progreso!",
            goToGrades: "Ir a la sección",
            seeAllGrades: "Mostrar todos mis ascensos de cinturón",
            gradeDate: "Fecha de ascenso",
            preparationGrade: "Preparación de cinturón",
            dominante: "Dominante",
            uv1: "UV1",
            uv2: "UV2",
            uv3Points: "Puntos UV3",
            uv4: "UV4",
            observations: "Observaciones",
            validated: "Validado",
            notValidated: "No validado",
            noNextBelt: "No hay cinturón siguiente definido.",
          },
          techniquesFavorites: {
            title: "Tokui Waza",
            subtitle: "Mis Técnicas Favoritas",
            notConnectedTitle: "Tus Técnicas Favoritas",
            notConnectedDescription:
              "Inicia sesión para ver tus técnicas favoritas y descubrir nuevas inspiraciones para tu práctica de judo.",
            loginOrRegister: "Iniciar sesión o registrarse",
            noTechniquesTitle: "Ninguna técnica favorita guardada",
            noTechniquesDescription:
              "Aún no has seleccionado tus técnicas favoritas. ¡Explora las técnicas de judo y añade tus favoritas!",
            exploreTechniques: "Explorar Técnicas",
            seeAllTechniques: "Ver Todas las Técnicas",
            family: "Familia",
          },
          diaporama: {
            introduction:
              "Aquí tienes una selección de algunas páginas de la aplicación.",
            menu: {
              alt: "Menú",
              caption: "Menú de la aplicación",
            },
            formules: {
              alt: "Planes",
              caption: "Planes gratuitos y de pago",
            },
            evenements: {
              alt: "Eventos",
              caption: "Consultar sus próximas competiciones o plazos",
            },
            evenementsPartages: {
              alt: "Eventos compartidos",
              caption:
                "Posibilidad de consultar eventos compartidos por otros usuarios y copiarlos en su agenda",
            },
            selectionDept: {
              alt: "Selección por departamento",
              caption: "Filtrado por departamento en un mapa interactivo",
            },
            resultats: {
              alt: "Resultados",
              caption: "Registro de sus resultados en los eventos",
            },
            palmares: {
              alt: "Palmarés",
              caption: "Añadir los resultados a su palmarés",
            },
            passages: {
              alt: "Examen de grados",
              caption: "Gestión de exámenes de grado y UV",
            },
            stats: {
              alt: "Estadísticas",
              caption: "Página de estadísticas de sus combates",
            },
            techniques: {
              alt: "Técnicas",
              caption: "Revisión de técnicas de Judo y Ju-Jitsu",
            },
            kata: {
              alt: "Kata",
              caption: "Revisión de los katas",
            },
            quizz: {
              alt: "Cuestionario",
              caption: "Cuestionarios técnicos",
            },
            lexique: {
              alt: "Glosario",
              caption: "Glosario Japonés-Español",
            },
            arbitrage: {
              alt: "Arbitraje",
              caption: "Reglamento de arbitraje y juez deportivo",
            },
            gestionGroupes: {
              alt: "Entrenador - Gestión de grupos y judokas",
              caption: "Gestión de grupos y judokas para entrenadores",
            },
            qrCode: {
              alt: "Invitación por código QR",
              caption: "Invitación mediante código QR para unirse a un grupo",
            },
            enregistrementResultats: {
              alt: "Registro de resultados",
              caption: "Registro de resultados de los judokas",
            },
            passagesGrades: {
              alt: "Registro de exámenes de grado",
              caption: "Registro de exámenes de grado de los judokas",
            },
          },
          formContact: {
            title: "Formulario de Contacto",
            intro: "¿Tienes preguntas o comentarios?",
            prompt: "No dudes en ponerte en contacto con nosotros.",
            email: "Tu correo electrónico",
            name: "Nombre y Apellido",
            message: "Tu Mensaje",
            sendButton: "Enviar",
            hoverLabel: "Enviar el mensaje",
            successMessage: "¡Tu mensaje ha sido enviado con éxito!",
          },
          profile: {
            title: "Perfil de Usuario",
            changePhoto: "Cambiar foto",
            chosenPlan: "Plan elegido",
            editInfo: "Editar información",
            selectAvatar: "Seleccionar un Avatar",
            editProfile: "Editar Perfil",
            lastName: "Apellido",
            firstName: "Nombre",
            cancel: "Cancelar",
            save: "Guardar",
            close: "Cerrar",
          },
          judokaProfile: {
            title: "Perfil de Judoka",
            changePhoto: "Cambiar foto",
            birthDate: "Fecha de nacimiento",
            weight: "Peso",
            license: "Licencia",
            club: "Club",
            country: "País",
            region: "Departamento / Provincia",
            notSpecified: "No especificado",
            editInfo: "Editar información",
            selectAvatar: "Seleccionar un Avatar",
            editProfile: "Editar el Perfil del Judoka",
            createProfile: "Crear un Perfil de Judoka",
            lastName: "Apellido",
            firstName: "Nombre",
            gender: "Género",
            selectGender: "Selecciona el género",
            male: "Masculino",
            female: "Femenino",
            cancel: "Cancelar",
            save: "Guardar",
          },
          judokaCategory: {
            title: "Categorías del Judoka",
            age: "Edad",
            years: "años",
            notDefined: "No definido",
            ageCategory: "Categoría de edad",
            weightCategory: "Categoría de peso",
          },
          joinGroup: {
            title: "Unirse a un grupo",
            description:
              "Escanea un código QR o ingresa un enlace de invitación para unirte a un grupo.",
            noRequests: "No tienes solicitudes pendientes.",
            pendingRequest:
              "Tu solicitud para unirte al grupo está pendiente de aprobación del entrenador.",
            approvedRequest: "Ahora eres miembro del grupo.",
            rejectedRequest:
              "Tu solicitud para unirte al grupo fue rechazada por el entrenador.",
            leaveGroup: "Salir del grupo",
            scanQr: "Escanear un código QR",
            scannedQr: "Código QR escaneado:",
            invalidQr: "No se encontró contenido válido en el código QR.",
            enterInviteLink: "Ingresa un enlace de invitación:",
            linkPlaceholder: "https://www.judo-coach-pro.com/join-group/...",
            submit: "Enviar",
            nocamera:
              "Si la cámara no funciona, ingrese directamente el enlace de invitación enviado por su entrenador.",
          },
          messagerie: {
            home: "Inicio",
            yourcount: "Tu Cuenta",
            messagerie: "Mensajería",
            messagerieTitle: "Tus Mensajes",
            sendAdminMessage: "Enviar un mensaje al administrador",
            sendJudokaMessage: "Enviar un mensaje a tus judokas",
            sendCoachMessage: "Enviar un mensaje a tu entrenador",
            receivedMessages: "Mensajes recibidos",
            loading: "Cargando mensajes...",
            noReadMessage: "Marcar como no leído",
            readMessage: "Marcar como leído",
            answer: "Responder",
            delete: "Eliminar",
            noMessages: "No hay mensajes para mostrar.",
            adminMessage: "Mensaje para el administrador",
            btnAnnuler: "Cancelar",
            btnEnvoyer: "Enviar",
            responseMessage: "Responder al mensaje",
          },
          pricing: {
            title: "Nuestras Tarifas",
            subtitle: "Elige un plan que se adapte a tus necesidades.",
            unauthenticated_user: "Usuario no autenticado",
            judo_expert: {
              name: "Judo Experto",
              price: "Gratis",
              features: [
                "Resultados, rankings, ascensos de cinturón y estadísticas",
                "Acceso a competiciones y eventos compartidos",
                "Técnicas, UV2, katas, Cuestionarios, Glosario",
                "Reglamento, Cuestionario de arbitraje, Marcador",
              ],
            },
            coach: {
              name: "Entrenador",
              price: "10 €",
              features: [
                "Judo Experto más ...",
                "Gestiona un grupo de hasta 10 miembros",
                "Mensajería privada y segura con tus miembros",
                "Invita y recibe respuestas para tus eventos",
                "Resultados, Rankings y Estadísticas de tus miembros",
              ],
            },
            coach_pro: {
              name: "Entrenador Pro",
              price: "20 €",
              features: [
                "Judo Entrenador más ...",
                "Gestiona 5 grupos, hasta 50 miembros",
              ],
            },
            coach_ultim: {
              name: "Entrenador Último",
              price: "30 €",
              features: [
                "Judo Entrenador Pro más ...",
                "Gestiona 10 grupos, más de 50 miembros",
              ],
            },
            notifications: {
              success:
                "¡Transacción exitosa! Haz clic en 'Actualizar Plan' para actualizar.",
              cancel: "Transacción cancelada.",
            },
            errors: {
              user_corrupted:
                "Tu información de usuario parece estar corrupta. Por favor, inicia sesión nuevamente.",
            },
            soutien: {
              title:
                "💙 Apoya a Judo Coach Pro y contribuye a su desarrollo 💙",
              description_1:
                "La aplicación Judo Coach Pro es una aplicación web gratuita para judokas, instalable en todo tipo de dispositivos (Android, iOS, tabletas, PC). Si crees que esta aplicación puede ayudarte en tu práctica del judo, puedes hacer una donación.",
              description_2:
                "Tu generosidad me ayudará a desarrollar nuevas funciones y a crear nuevas aplicaciones relacionadas con el Judo. Gracias de antemano. 🙏",
              button: "Hacer una donación de 5 €",
            },
          },
        },
      },
      it: {
        translation: {
          menu: {
            open: "MENU",
            close: "CHIUDI",
            home: "Home",
            performanceApp: "Applicazione Prestazioni Judo",
            profile: "Profilo Utente",
            judokaProfile: "Profilo Judoka",
            joinGroup: "Unisciti a un Gruppo",
            messages: "Messaggi",
            messages_form: "Messaggio del Modulo",
            dashboard: "Cruscotto",
            profilutilisateur: "Profilo Utente",
            pricing: "Piani e Prezzi",
            results: "Risultati",
            ranking: "Classifica",
            grading: "Promozione Cintura",
            statistics: "Statistiche",
            techniques: "Tecniche",
            quiz: "Quiz",
            kata: "Kata",
            lexicon: "Lessico",
            arbitration: "Arbitraggio",
            logout: "Disconnettersi",
            login: "Accedi",
            register: "Registrati",
            account: "Account",
            userProfile: "Profilo Utente",
            pricingPlans: "Piani e Prezzi",
            agenda: "Agenda",
            yourCompetitions: "Le Tue Competizioni",
            sharedCompetitions: "Competizioni Condivise",
            performances: "Prestazioni",
            techniquesReview: "Revisione delle Tecniche",
            uv2Review: "Revisione UV2",
            katas: "Katas",
            techniquesQuiz: "Quiz Tecniche",
            refereeing: "Arbitraggio",
            refereeingRules: "Regole di Arbitraggio",
            csRules: "Regole CS",
            refereeingQuiz: "Quiz Arbitraggio",
            scoreboard: "Tabellone",
            yourGroups: "I Tuoi Gruppi e Inviti",
            groupResults: "Risultati e Successi dei tuoi Judoka",
            groupGrading: "Promozione Cintura dei tuoi Judoka",
            groupStatistics: "Statistiche",
          },
          homeHero: {
            performancesTitle: "PRESTAZIONI",
            performancesSubtitle:
              "Risultati, Classifiche, Promozioni di Cintura e Statistiche",
            performancesDescription:
              "Segui le tue prestazioni e valuta i tuoi progressi nelle competizioni.",

            techniquesTitle: "TECNICHE",
            techniquesSubtitle: "Rivedi le tue tecniche, UV2, kata e lessico",
            techniquesDescription:
              "Impara e perfeziona le tue tecniche con strumenti interattivi.",

            agendaTitle: "AGENDA",
            agendaSubtitle: "Competizioni ed eventi condivisi",
            agendaDescription:
              "Organizza e segui facilmente le tue competizioni.",

            coachTitle: "ALLENATORE",
            coachSubtitle: "Gruppi, Statistiche e Messaggistica",
            coachDescription:
              "Gestisci i tuoi gruppi, controlla i loro risultati e comunica con i tuoi judoka.",

            discover: "Scoprire",
          },
          agenda: {
            title: "Agenda",
            subtitle: "Le tue prossime competizioni ed eventi",
            notConnectedTitle: "I tuoi prossimi eventi",
            notConnectedDescription:
              "Accedi per vedere i tuoi prossimi eventi e competizioni. Se non hai ancora un account, inizia creando un profilo per accedere a tutte queste funzionalità.",
            loginOrRegister: "Accedi o Registrati",
            noEventsTitle: "Nessun evento imminente",
            noEventsDescription:
              "Non sono ancora programmati eventi. Torna presto per vedere le tue prossime competizioni!",
            goToEvents: "Vai alla sezione eventi",
            myNextEvents: "I tuoi prossimi eventi",
            eventDetails: "Vedi dettagli",
            close: "Chiudi",
            seeAllEvents: "Vedi tutti gli eventi",
          },
          results: {
            title: "Risultati",
            subtitle: "I tuoi ultimi risultati in competizione",
            notConnectedTitle: "I tuoi risultati di competizione",
            notConnectedDescription:
              "Accedi per vedere i tuoi ultimi risultati, classifiche, osservazioni e altro. Se non hai ancora un account, inizia creando un profilo per accedere a tutte queste funzionalità.",
            loginOrRegister: "Accedi o Registrati",
            noResultsTitle: "Nessun risultato disponibile",
            noResultsDescription:
              "Ora puoi registrare i risultati delle tue competizioni per visualizzarli facilmente qui.",
            goToResults: "Vai alla sezione dei risultati",
            table: {
              date: "Data",
              title: "Titolo",
              ranking: "Classifica",
              results: "Risultati",
              observations: "Osservazioni",
            },
            seeAllResults: "Mostra tutti i miei risultati",
          },
          palmares: {
            title: "Classifiche",
            subtitle: "Le tue ultime classifiche",
            notConnectedTitle: "Le tue ultime classifiche",
            notConnectedDescription:
              "Accedi per registrare e scoprire le tue ultime performance in competizione. Accedi alle tue classifiche e condividi i tuoi successi!",
            loginOrRegister: "Accedi o Registrati",
            noPalmaresTitle: "Nessuna classifica disponibile",
            noPalmaresDescription:
              "Non hai ancora risultati registrati nelle tue classifiche. Partecipa alle competizioni e tieni traccia dei tuoi successi!",
            goToPalmares: "Vai alla sezione Classifiche",
            seeAllPalmares: "Visualizza Classifiche",
          },
          passageGrade: {
            title: "Promozioni di Cintura",
            subtitle: "Le tue ultime promozioni di cintura",
            notConnectedTitle: "Le tue promozioni di cintura",
            notConnectedDescription:
              "Accedi per visualizzare le tue ultime promozioni di cintura e seguire il tuo progresso.",
            loginOrRegister: "Accedi o Registrati",
            noGradesTitle: "Nessuna promozione di cintura registrata",
            noGradesDescription:
              "Non hai ancora registrato alcuna promozione di cintura. Inizia ora a tenere traccia del tuo progresso!",
            goToGrades: "Vai alla sezione",
            seeAllGrades: "Mostra tutte le mie promozioni di cintura",
            gradeDate: "Data di promozione",
            preparationGrade: "Preparazione Cintura",
            dominante: "Dominante",
            uv1: "UV1",
            uv2: "UV2",
            uv3Points: "Punti UV3",
            uv4: "UV4",
            observations: "Osservazioni",
            validated: "Convalidato",
            notValidated: "Non convalidato",
            noNextBelt: "Nessuna cintura successiva definita.",
          },
          techniquesFavorites: {
            title: "Tokui Waza",
            subtitle: "Le Mie Tecniche Preferite",
            notConnectedTitle: "Le Tue Tecniche Preferite",
            notConnectedDescription:
              "Accedi per visualizzare le tue tecniche preferite e scoprire nuove ispirazioni per la tua pratica del judo.",
            loginOrRegister: "Accedi o registrati",
            noTechniquesTitle: "Nessuna tecnica preferita salvata",
            noTechniquesDescription:
              "Non hai ancora selezionato le tue tecniche preferite. Esplora le tecniche di judo e aggiungi le tue preferite!",
            exploreTechniques: "Esplora Tecniche",
            seeAllTechniques: "Visualizza Tutte le Tecniche",
            family: "Famiglia",
          },
          diaporama: {
            introduction:
              "Ecco una selezione di alcune pagine dell'applicazione.",
            menu: {
              alt: "Menu",
              caption: "Menu dell'applicazione",
            },
            formules: {
              alt: "Piani",
              caption: "Piani gratuiti e a pagamento",
            },
            evenements: {
              alt: "Eventi",
              caption: "Consulta le tue prossime competizioni o scadenze",
            },
            evenementsPartages: {
              alt: "Eventi condivisi",
              caption:
                "Possibilità di consultare eventi condivisi da altri utenti e copiarli nel proprio calendario",
            },
            selectionDept: {
              alt: "Selezione per dipartimento",
              caption: "Filtraggio per dipartimento su una mappa interattiva",
            },
            resultats: {
              alt: "Risultati",
              caption: "Registrazione dei propri risultati negli eventi",
            },
            palmares: {
              alt: "Palmarès",
              caption: "Aggiunta dei risultati al proprio palmarès",
            },
            passages: {
              alt: "Passaggio di grado",
              caption: "Gestione dei passaggi di grado e UV",
            },
            stats: {
              alt: "Statistiche",
              caption: "Pagina delle statistiche dei propri combattimenti",
            },
            techniques: {
              alt: "Tecniche",
              caption: "Revisione delle tecniche di Judo e Ju-Jitsu",
            },
            kata: {
              alt: "Kata",
              caption: "Revisione dei kata",
            },
            quizz: {
              alt: "Quiz",
              caption: "Quiz tecnici",
            },
            lexique: {
              alt: "Lessico",
              caption: "Lessico Giapponese-Italiano",
            },
            arbitrage: {
              alt: "Arbitraggio",
              caption: "Regolamento di arbitraggio e giudice sportivo",
            },
            gestionGroupes: {
              alt: "Allenatore - Gestione di gruppi e judoka",
              caption: "Gestione di gruppi e judoka per gli allenatori",
            },
            qrCode: {
              alt: "Invito tramite codice QR",
              caption: "Invito tramite codice QR per unirsi a un gruppo",
            },
            enregistrementResultats: {
              alt: "Registrazione dei risultati",
              caption: "Registrazione dei risultati dei judoka",
            },
            passagesGrades: {
              alt: "Registrazione dei passaggi di grado",
              caption: "Registrazione dei passaggi di grado dei judoka",
            },
          },
          formContact: {
            title: "Modulo di Contatto",
            intro: "Hai domande o commenti?",
            prompt: "Non esitare a contattarci.",
            email: "La tua email",
            name: "Nome e Cognome",
            message: "Il tuo Messaggio",
            sendButton: "Inviare",
            hoverLabel: "Inviare il messaggio",
            successMessage: "Il tuo messaggio è stato inviato con successo!",
          },
          profile: {
            title: "Profilo Utente",
            changePhoto: "Modifica foto",
            chosenPlan: "Piano scelto",
            editInfo: "Modifica informazioni",
            selectAvatar: "Seleziona un Avatar",
            editProfile: "Modifica Profilo",
            lastName: "Cognome",
            firstName: "Nome",
            cancel: "Annulla",
            save: "Salva",
            close: "Chiudi",
          },
          judokaProfile: {
            title: "Profilo Judoka",
            changePhoto: "Modifica foto",
            birthDate: "Data di nascita",
            weight: "Peso",
            license: "Licenza",
            club: "Club",
            country: "Paese",
            region: "Dipartimento / Provincia",
            notSpecified: "Non specificato",
            editInfo: "Modifica informazioni",
            selectAvatar: "Seleziona un Avatar",
            editProfile: "Modifica il Profilo Judoka",
            createProfile: "Crea un Profilo Judoka",
            lastName: "Cognome",
            firstName: "Nome",
            gender: "Genere",
            selectGender: "Seleziona il genere",
            male: "Maschile",
            female: "Femminile",
            cancel: "Annulla",
            save: "Salva",
          },
          judokaCategory: {
            title: "Categorie del Judoka",
            age: "Età",
            years: "anni",
            notDefined: "Non definito",
            ageCategory: "Categoria di età",
            weightCategory: "Categoria di peso",
          },
          joinGroup: {
            title: "Unirsi a un gruppo",
            description:
              "Scansiona un codice QR o inserisci un link di invito per unirti a un gruppo.",
            noRequests: "Non hai richieste in sospeso.",
            pendingRequest:
              "La tua richiesta per unirti al gruppo è in attesa di approvazione dell'allenatore.",
            approvedRequest: "Ora sei membro del gruppo.",
            rejectedRequest:
              "La tua richiesta per unirti al gruppo è stata rifiutata dall'allenatore.",
            leaveGroup: "Lascia il gruppo",
            scanQr: "Scansiona un codice QR",
            scannedQr: "Codice QR scansionato:",
            invalidQr: "Nessun contenuto valido trovato nel codice QR.",
            enterInviteLink: "Inserisci un link di invito:",
            linkPlaceholder: "https://www.judo-coach-pro.com/join-group/...",
            submit: "Invia",
            nocamera:
              "Se la fotocamera non funziona, inserisci direttamente il link di invito inviato dal tuo allenatore.",
          },
          messagerie: {
            home: "Home",
            yourcount: "Il tuo Account",
            messagerie: "Messaggistica",
            messagerieTitle: "I tuoi Messaggi",
            sendAdminMessage: "Invia un messaggio all'amministratore",
            sendJudokaMessage: "Invia un messaggio ai tuoi judoka",
            sendCoachMessage: "Invia un messaggio al tuo allenatore",
            receivedMessages: "Messaggi ricevuti",
            loading: "Caricamento dei messaggi...",
            noReadMessage: "Segna come non letto",
            readMessage: "Segna come letto",
            answer: "Rispondere",
            delete: "Elimina",
            noMessages: "Nessun messaggio da visualizzare.",
            adminMessage: "Messaggio per l'amministratore",
            btnAnnuler: "Annulla",
            btnEnvoyer: "Invia",
            responseMessage: "Rispondi al messaggio",
          },
          pricing: {
            title: "I Nostri Piani",
            subtitle: "Scegli un piano adatto alle tue esigenze.",
            unauthenticated_user: "Utente non autenticato",
            judo_expert: {
              name: "Judo Esperto",
              price: "Gratuito",
              features: [
                "Risultati, classifiche, passaggi di cintura e statistiche",
                "Accesso a competizioni ed eventi condivisi",
                "Tecniche, UV2, kata, Quiz, Glossario",
                "Regolamento, Quiz arbitrale, Tabellone segnapunti",
              ],
            },
            coach: {
              name: "Allenatore",
              price: "10 €",
              features: [
                "Judo Esperto più ...",
                "Gestione di un gruppo fino a 10 membri",
                "Messaggistica privata e sicura con i tuoi membri",
                "Invito e ricezione delle risposte per i tuoi eventi",
                "Risultati, Classifiche e Statistiche dei tuoi membri",
              ],
            },
            coach_pro: {
              name: "Allenatore Pro",
              price: "20 €",
              features: [
                "Judo Allenatore più ...",
                "Gestione di 5 gruppi, fino a 50 membri",
              ],
            },
            coach_ultim: {
              name: "Allenatore Ultim",
              price: "30 €",
              features: [
                "Judo Allenatore Pro più ...",
                "Gestione di 10 gruppi, più di 50 membri",
              ],
            },
            notifications: {
              success:
                "Transazione riuscita! Clicca su 'Aggiorna Piano' per aggiornare.",
              cancel: "Transazione annullata.",
            },
            errors: {
              user_corrupted:
                "Le tue informazioni utente sembrano essere corrotte. Effettua nuovamente l'accesso.",
            },
            soutien: {
              title:
                "💙 Sostieni Judo Coach Pro e contribuisci alla sua crescita 💙",
              description_1:
                "L'app Judo Coach Pro è un'app web gratuita per i judoka, installabile su tutti i tipi di dispositivi (Android, iOS, tablet, PC). Se pensi che questa app possa aiutarti nella pratica del judo, puoi fare una donazione.",
              description_2:
                "La tua generosità mi aiuterà a sviluppare nuove funzionalità e a creare nuove applicazioni legate al Judo. Grazie in anticipo. 🙏",
              button: "Fai una donazione di 5 €",
            },
          },
        },
      },
      de: {
        translation: {
          menu: {
            open: "MENÜ",
            close: "SCHLIESSEN",
            home: "Startseite",
            performanceApp: "Judo-Leistungsanwendung",
            profile: "Benutzerprofil",
            judokaProfile: "Judoka-Profil",
            joinGroup: "Einer Gruppe beitreten",
            messages: "Nachrichten",
            messages_form: "Nachrichtenformular",
            dashboard: "Dashboard",
            profilutilisateur: "Benutzerprofil",
            pricing: "Pläne und Preise",
            results: "Ergebnisse",
            ranking: "Rangliste",
            grading: "Gürtelprüfung",
            statistics: "Statistiken",
            techniques: "Techniken",
            quiz: "Quiz",
            kata: "Kata",
            lexicon: "Lexikon",
            arbitration: "Schiedsrichterwesen",
            logout: "Abmelden",
            login: "Anmelden",
            register: "Registrieren",
            account: "Konto",
            userProfile: "Benutzerprofil",
            pricingPlans: "Pläne und Preise",
            agenda: "Agenda",
            yourCompetitions: "Ihre Wettbewerbe",
            sharedCompetitions: "Geteilte Wettbewerbe",
            performances: "Leistungen",
            techniquesReview: "Techniküberprüfung",
            uv2Review: "UV2-Überprüfung",
            katas: "Katas",
            techniquesQuiz: "Technik-Quiz",
            refereeing: "Schiedsrichterwesen",
            refereeingRules: "Schiedsrichterregeln",
            csRules: "CS-Regeln",
            refereeingQuiz: "Schiedsrichter-Quiz",
            scoreboard: "Punktestand",
            yourGroups: "Ihre Gruppen & Einladungen",
            groupResults: "Ergebnisse & Leistungen Ihrer Judokas",
            groupGrading: "Gürtelprüfung Ihrer Judokas",
            groupStatistics: "Statistiken",
          },
          homeHero: {
            performancesTitle: "LEISTUNGEN",
            performancesSubtitle:
              "Ergebnisse, Ranglisten, Gürtelprüfungen und Statistiken",
            performancesDescription:
              "Verfolgen Sie Ihre Leistungen und bewerten Sie Ihren Fortschritt in Wettbewerben.",

            techniquesTitle: "TECHNIKEN",
            techniquesSubtitle:
              "Überprüfen Sie Ihre Techniken, UV2, Kata und Lexikon",
            techniquesDescription:
              "Lernen und verfeinern Sie Ihre Techniken mit interaktiven Tools.",

            agendaTitle: "AGENDA",
            agendaSubtitle: "Wettbewerbe und geteilte Veranstaltungen",
            agendaDescription:
              "Organisieren und verfolgen Sie Ihre Wettbewerbe einfach.",

            coachTitle: "TRAINER",
            coachSubtitle: "Gruppen, Statistiken und Messaging",
            coachDescription:
              "Verwalten Sie Ihre Gruppen, überprüfen Sie ihre Ergebnisse und kommunizieren Sie mit Ihren Judoka.",

            discover: "Entdecken",
          },
          agenda: {
            title: "Agenda",
            subtitle: "Meine bevorstehenden Wettbewerbe & Veranstaltungen",
            notConnectedTitle: "Ihre bevorstehenden Veranstaltungen",
            notConnectedDescription:
              "Melden Sie sich an, um Ihre bevorstehenden Veranstaltungen und Wettbewerbe zu sehen. Wenn Sie noch kein Konto haben, beginnen Sie damit, ein Profil zu erstellen, um auf all diese Funktionen zuzugreifen.",
            loginOrRegister: "Anmelden oder Registrieren",
            noEventsTitle: "Keine bevorstehenden Veranstaltungen",
            noEventsDescription:
              "Es sind noch keine Veranstaltungen geplant. Schauen Sie bald wieder vorbei, um Ihre bevorstehenden Wettbewerbe zu sehen!",
            goToEvents: "Zur Veranstaltungssektion gehen",
            myNextEvents: "Meine bevorstehenden Veranstaltungen",
            eventDetails: "Details anzeigen",
            close: "Schließen",
            seeAllEvents: "Alle Veranstaltungen anzeigen",
          },
          results: {
            title: "Ergebnisse",
            subtitle: "Meine letzten Wettkampfergebnisse",
            notConnectedTitle: "Ihre Wettkampfergebnisse",
            notConnectedDescription:
              "Melden Sie sich an, um Ihre letzten Ergebnisse, Platzierungen, Beobachtungen und mehr zu sehen. Wenn Sie noch kein Konto haben, beginnen Sie damit, ein Profil zu erstellen, um auf all diese Funktionen zuzugreifen.",
            loginOrRegister: "Anmelden oder Registrieren",
            noResultsTitle: "Keine Ergebnisse verfügbar",
            noResultsDescription:
              "Sie können jetzt Ihre Wettkampfergebnisse erfassen, um sie hier leichter anzuzeigen.",
            goToResults: "Zur Ergebnissektion gehen",
            table: {
              date: "Datum",
              title: "Titel",
              ranking: "Platzierung",
              results: "Ergebnisse",
              observations: "Beobachtungen",
            },
            seeAllResults: "Alle meine Ergebnisse anzeigen",
          },
          palmares: {
            title: "Ranglisten",
            subtitle: "Meine letzten Ranglisten",
            notConnectedTitle: "Ihre letzten Ranglisten",
            notConnectedDescription:
              "Melden Sie sich an, um Ihre letzten Wettkampfleistungen zu erfassen und zu entdecken. Greifen Sie auf Ihre Ranglisten zu und teilen Sie Ihre Erfolge!",
            loginOrRegister: "Anmelden oder Registrieren",
            noPalmaresTitle: "Keine Ranglisten verfügbar",
            noPalmaresDescription:
              "Sie haben noch keine Ergebnisse in Ihren Ranglisten erfasst. Nehmen Sie an Wettbewerben teil und verfolgen Sie Ihre Erfolge!",
            goToPalmares: "Zur Ranglistensektion gehen",
            seeAllPalmares: "Ranglisten anzeigen",
          },
          passageGrade: {
            title: "Gürtelprüfungen",
            subtitle: "Meine letzten Gürtelprüfungen",
            notConnectedTitle: "Ihre Gürtelprüfungen",
            notConnectedDescription:
              "Melden Sie sich an, um Ihre letzten Gürtelprüfungen einzusehen und Ihre Fortschritte zu verfolgen.",
            loginOrRegister: "Anmelden oder Registrieren",
            noGradesTitle: "Keine Gürtelprüfung eingetragen",
            noGradesDescription:
              "Sie haben noch keine Gürtelprüfung eingetragen. Beginnen Sie jetzt, um Ihre Fortschritte zu verfolgen!",
            goToGrades: "Zur Sektion gehen",
            seeAllGrades: "Alle meine Gürtelprüfungen anzeigen",
            gradeDate: "Prüfungsdatum",
            preparationGrade: "Vorbereitung auf die Prüfung",
            dominante: "Schwerpunkt",
            uv1: "UV1",
            uv2: "UV2",
            uv3Points: "UV3 Punkte",
            uv4: "UV4",
            observations: "Anmerkungen",
            validated: "Bestanden",
            notValidated: "Nicht bestanden",
            noNextBelt: "Kein nächster Gürtel definiert.",
          },
          techniquesFavorites: {
            title: "Tokui Waza",
            subtitle: "Meine Lieblingstechniken",
            notConnectedTitle: "Ihre Lieblingstechniken",
            notConnectedDescription:
              "Melden Sie sich an, um Ihre bevorzugten Techniken zu sehen und neue Inspirationen für Ihr Judo-Training zu entdecken.",
            loginOrRegister: "Anmelden oder registrieren",
            noTechniquesTitle: "Keine Lieblingstechniken gespeichert",
            noTechniquesDescription:
              "Sie haben noch keine bevorzugten Techniken ausgewählt. Erkunden Sie die Judotechniken und fügen Sie Ihre Favoriten hinzu!",
            exploreTechniques: "Techniken erkunden",
            seeAllTechniques: "Alle Techniken anzeigen",
            family: "Familie",
          },
          diaporama: {
            introduction: "Hier ist eine Auswahl einiger Seiten der Anwendung.",
            menu: {
              alt: "Menü",
              caption: "Menü der Anwendung",
            },
            formules: {
              alt: "Pläne",
              caption: "Kostenlose und kostenpflichtige Pläne",
            },
            evenements: {
              alt: "Veranstaltungen",
              caption: "Kommende Wettkämpfe oder Termine einsehen",
            },
            evenementsPartages: {
              alt: "Geteilte Veranstaltungen",
              caption:
                "Möglichkeit, von anderen Nutzern geteilte Veranstaltungen einzusehen und in den eigenen Kalender zu übernehmen",
            },
            selectionDept: {
              alt: "Auswahl nach Region",
              caption: "Filterung nach Region auf einer interaktiven Karte",
            },
            resultats: {
              alt: "Ergebnisse",
              caption: "Speicherung der eigenen Ergebnisse bei Veranstaltungen",
            },
            palmares: {
              alt: "Palmarès",
              caption: "Hinzufügen von Ergebnissen zur eigenen Erfolgsbilanz",
            },
            passages: {
              alt: "Gürtelprüfungen",
              caption: "Verwaltung von Gürtelprüfungen & UV",
            },
            stats: {
              alt: "Statistiken",
              caption: "Statistikseite über die eigenen Kämpfe",
            },
            techniques: {
              alt: "Techniken",
              caption: "Überprüfung der Techniken im Judo und Ju-Jitsu",
            },
            kata: {
              alt: "Kata",
              caption: "Überprüfung der Kata",
            },
            quizz: {
              alt: "Quiz",
              caption: "Technik-Quiz",
            },
            lexique: {
              alt: "Lexikon",
              caption: "Japanisch-Deutsches Lexikon",
            },
            arbitrage: {
              alt: "Schiedsrichter",
              caption: "Regelwerk für Schiedsrichter und Wettkampfkommissare",
            },
            gestionGroupes: {
              alt: "Trainer - Verwaltung von Gruppen und Judoka",
              caption: "Verwaltung von Gruppen und Judoka für Trainer",
            },
            qrCode: {
              alt: "Einladung per QR-Code",
              caption: "Einladung per QR-Code zur Teilnahme an einer Gruppe",
            },
            enregistrementResultats: {
              alt: "Erfassung der Ergebnisse",
              caption: "Erfassung der Ergebnisse der Judoka",
            },
            passagesGrades: {
              alt: "Erfassung der Gürtelprüfungen",
              caption: "Erfassung der Gürtelprüfungen der Judoka",
            },
          },
          formContact: {
            title: "Kontaktformular",
            intro: "Haben Sie Fragen oder Anmerkungen?",
            prompt: "Zögern Sie nicht, uns zu kontaktieren.",
            email: "Ihre E-Mail",
            name: "Vor- und Nachname",
            message: "Ihre Nachricht",
            sendButton: "Senden",
            hoverLabel: "Nachricht senden",
            successMessage: "Ihre Nachricht wurde erfolgreich gesendet!",
          },
          profile: {
            title: "Benutzerprofil",
            changePhoto: "Foto ändern",
            chosenPlan: "Gewählter Plan",
            editInfo: "Informationen bearbeiten",
            selectAvatar: "Avatar auswählen",
            editProfile: "Profil bearbeiten",
            lastName: "Nachname",
            firstName: "Vorname",
            cancel: "Abbrechen",
            save: "Speichern",
            close: "Schließen",
          },
          judokaProfile: {
            title: "Judoka-Profil",
            changePhoto: "Foto ändern",
            birthDate: "Geburtsdatum",
            weight: "Gewicht",
            license: "Lizenz",
            club: "Verein",
            country: "Land",
            region: "Bundesland / Provinz",
            notSpecified: "Nicht angegeben",
            editInfo: "Informationen bearbeiten",
            selectAvatar: "Avatar auswählen",
            editProfile: "Judoka-Profil bearbeiten",
            createProfile: "Judoka-Profil erstellen",
            lastName: "Nachname",
            firstName: "Vorname",
            gender: "Geschlecht",
            selectGender: "Geschlecht auswählen",
            male: "Männlich",
            female: "Weiblich",
            cancel: "Abbrechen",
            save: "Speichern",
          },
          judokaCategory: {
            title: "Kategorien des Judoka",
            age: "Alter",
            years: "Jahre",
            notDefined: "Nicht definiert",
            ageCategory: "Alterskategorie",
            weightCategory: "Gewichtskategorie",
          },
          joinGroup: {
            title: "Einer Gruppe beitreten",
            description:
              "Scannen Sie einen QR-Code oder geben Sie einen Einladungslink ein, um einer Gruppe beizutreten.",
            noRequests: "Sie haben keine ausstehenden Anfragen.",
            pendingRequest:
              "Ihre Anfrage zum Beitritt zur Gruppe wartet auf die Genehmigung des Trainers.",
            approvedRequest: "Sie sind jetzt Mitglied der Gruppe.",
            rejectedRequest:
              "Ihre Anfrage zum Beitritt zur Gruppe wurde vom Trainer abgelehnt.",
            leaveGroup: "Gruppe verlassen",
            scanQr: "QR-Code scannen",
            scannedQr: "Gescanntes QR-Code:",
            invalidQr: "Kein gültiger Inhalt im QR-Code gefunden.",
            enterInviteLink: "Geben Sie einen Einladungslink ein:",
            linkPlaceholder: "https://www.judo-coach-pro.com/join-group/...",
            submit: "Absenden",
            nocamera:
              "Wenn die Kamera nicht funktioniert, geben Sie den Einladungslink direkt ein, den Ihr Trainer gesendet hat.",
          },
          messagerie: {
            home: "Startseite",
            yourcount: "Dein Konto",
            messagerie: "Nachrichten",
            messagerieTitle: "Deine Nachrichten",
            sendAdminMessage: "Eine Nachricht an den Administrator senden",
            sendJudokaMessage: "Eine Nachricht an deine Judokas senden",
            sendCoachMessage: "Eine Nachricht an deinen Trainer senden",
            receivedMessages: "Erhaltene Nachrichten",
            loading: "Nachrichten werden geladen...",
            noReadMessage: "Als ungelesen markieren",
            readMessage: "Als gelesen markieren",
            answer: "Antworten",
            delete: "Löschen",
            noMessages: "Keine Nachrichten zum Anzeigen.",
            adminMessage: "Nachricht an den Administrator",
            btnAnnuler: "Abbrechen",
            btnEnvoyer: "Senden",
            responseMessage: "Auf die Nachricht antworten",
          },
          pricing: {
            title: "Unsere Tarife",
            subtitle:
              "Wählen Sie einen Plan, der Ihren Bedürfnissen entspricht.",
            unauthenticated_user: "Nicht authentifizierter Benutzer",
            judo_expert: {
              name: "Judo Experte",
              price: "Kostenlos",
              features: [
                "Ergebnisse, Ranglisten, Gürtelprüfung und Statistiken",
                "Zugang zu gemeinsamen Wettkämpfen und Veranstaltungen",
                "Techniken, UV2, Kata, Quiz, Lexikon",
                "Regeln, Schiedsrichter-Quiz, Anzeigetafel",
              ],
            },
            coach: {
              name: "Trainer",
              price: "10 €",
              features: [
                "Judo Experte plus ...",
                "Verwaltung einer Gruppe mit bis zu 10 Mitgliedern",
                "Private und sichere Nachrichten mit Ihren Mitgliedern",
                "Einladungen und Empfang von Antworten zu Ihren Veranstaltungen",
                "Ergebnisse, Ranglisten und Statistiken Ihrer Mitglieder",
              ],
            },
            coach_pro: {
              name: "Trainer Pro",
              price: "20 €",
              features: [
                "Judo Trainer plus ...",
                "Verwaltung von 5 Gruppen mit bis zu 50 Mitgliedern",
              ],
            },
            coach_ultim: {
              name: "Trainer Ultim",
              price: "30 €",
              features: [
                "Judo Trainer Pro plus ...",
                "Verwaltung von 10 Gruppen mit mehr als 50 Mitgliedern",
              ],
            },
            notifications: {
              success:
                "Transaktion erfolgreich! Klicken Sie auf 'Plan aktualisieren', um die Änderungen anzuzeigen.",
              cancel: "Transaktion abgebrochen.",
            },
            errors: {
              user_corrupted:
                "Ihre Benutzerdaten scheinen beschädigt zu sein. Bitte melden Sie sich erneut an.",
            },
            soutien: {
              title:
                "💙 Unterstützen Sie Judo Coach Pro und tragen Sie zu seiner Weiterentwicklung bei 💙",
              description_1:
                "Die Judo Coach Pro App ist eine kostenlose Web-App für Judoka, die auf allen Gerätetypen (Android, iOS, Tablets, PC) installiert werden kann. Wenn Sie glauben, dass diese App Ihnen bei Ihrem Judo-Training helfen kann, können Sie eine Spende machen.",
              description_2:
                "Ihre Großzügigkeit wird mir helfen, neue Funktionen zu entwickeln und neue Anwendungen im Zusammenhang mit Judo zu erstellen. Vielen Dank im Voraus. 🙏",
              button: "Spenden Sie 5 €",
            },
          },
        },
      },
      pt: {
        translation: {
          menu: {
            open: "MENU",
            close: "FECHAR",
            home: "Início",
            performanceApp: "Aplicativo de Desempenho de Judo",
            profile: "Perfil do Usuário",
            judokaProfile: "Perfil do Judoca",
            joinGroup: "Entrar em um Grupo",
            messages: "Mensagens",
            messages_form: "Mensagem do Formulário",
            dashboard: "Painel de Controle",
            profilutilisateur: "Perfil do Usuário",
            pricing: "Planos e Preços",
            results: "Resultados",
            ranking: "Classificação",
            grading: "Promoção de Faixa",
            statistics: "Estatísticas",
            techniques: "Técnicas",
            quiz: "Quiz",
            kata: "Kata",
            lexicon: "Léxico",
            arbitration: "Arbitragem",
            logout: "Sair",
            login: "Entrar",
            register: "Registrar",
            account: "Conta",
            userProfile: "Perfil do Usuário",
            pricingPlans: "Planos e Preços",
            agenda: "Agenda",
            yourCompetitions: "Suas Competições",
            sharedCompetitions: "Competições Compartilhadas",
            performances: "Desempenho",
            techniquesReview: "Revisão de Técnicas",
            uv2Review: "Revisão UV2",
            katas: "Katas",
            techniquesQuiz: "Quiz de Técnicas",
            refereeing: "Arbitragem",
            refereeingRules: "Regras de Arbitragem",
            csRules: "Regras de CS",
            refereeingQuiz: "Quiz de Arbitragem",
            scoreboard: "Placar",
            yourGroups: "Seus Grupos e Convites",
            groupResults: "Resultados e Conquistas dos seus Judocas",
            groupGrading: "Promoção de Faixa dos seus Judocas",
            groupStatistics: "Estatísticas",
          },
          homeHero: {
            performancesTitle: "DESEMPENHO",
            performancesSubtitle:
              "Resultados, Classificações, Promoções de Faixa e Estatísticas",
            performancesDescription:
              "Acompanhe seu desempenho e avalie seu progresso nas competições.",
            techniquesTitle: "TÉCNICAS",
            techniquesSubtitle: "Revise suas técnicas, UV2, kata e léxico",
            techniquesDescription:
              "Aprenda e aprimore suas técnicas com ferramentas interativas.",
            agendaTitle: "AGENDA",
            agendaSubtitle: "Competições e eventos compartilhados",
            agendaDescription:
              "Organize e acompanhe suas competições facilmente.",
            coachTitle: "TREINADOR",
            coachSubtitle: "Grupos, Estatísticas e Mensagens",
            coachDescription:
              "Gerencie seus grupos, verifique seus resultados e comunique-se com seus judocas.",
            discover: "Descobrir",
          },
          agenda: {
            title: "Agenda",
            subtitle: "Minhas próximas competições e eventos",
            notConnectedTitle: "Seus próximos eventos",
            notConnectedDescription:
              "Faça login para ver seus próximos eventos e competições. Se você ainda não tem uma conta, comece criando um perfil para acessar todos esses recursos.",
            loginOrRegister: "Entrar ou Registrar",
            noEventsTitle: "Nenhum evento próximo",
            noEventsDescription:
              "Nenhum evento está agendado ainda. Volte em breve para ver suas próximas competições!",
            goToEvents: "Ir para a seção de eventos",
            myNextEvents: "Meus próximos eventos",
            eventDetails: "Ver detalhes",
            close: "Fechar",
            seeAllEvents: "Ver todos os eventos",
          },
          results: {
            title: "Resultados",
            subtitle: "Meus últimos resultados em competição",
            notConnectedTitle: "Seus resultados de competição",
            notConnectedDescription:
              "Faça login para ver seus últimos resultados, classificações, observações e muito mais. Se você ainda não tem uma conta, comece criando um perfil para acessar todos esses recursos.",
            loginOrRegister: "Entrar ou Registrar",
            noResultsTitle: "Nenhum resultado disponível",
            noResultsDescription:
              "Você pode agora registrar seus resultados de competição para visualizá-los facilmente aqui.",
            goToResults: "Ir para a seção de resultados",
            table: {
              date: "Data",
              title: "Título",
              ranking: "Classificação",
              results: "Resultados",
              observations: "Observações",
            },
            seeAllResults: "Mostrar todos os meus resultados",
          },
          palmares: {
            title: "Classificações",
            subtitle: "Minhas últimas classificações",
            notConnectedTitle: "Suas últimas classificações",
            notConnectedDescription:
              "Faça login para registrar e descobrir suas últimas performances em competição. Acesse suas classificações e compartilhe suas conquistas!",
            loginOrRegister: "Entrar ou Registrar",
            noPalmaresTitle: "Nenhuma classificação disponível",
            noPalmaresDescription:
              "Você ainda não tem resultados registrados em suas classificações. Participe de competições e acompanhe suas conquistas!",
            goToPalmares: "Ir para a seção de Classificações",
            seeAllPalmares: "Ver Classificações",
          },
          passageGrade: {
            title: "Exames de Graduação",
            subtitle: "Minhas últimas graduações",
            notConnectedTitle: "Seus exames de graduação",
            notConnectedDescription:
              "Conecte-se para visualizar suas últimas graduações e acompanhar seu progresso.",
            loginOrRegister: "Entrar ou Registrar-se",
            noGradesTitle: "Nenhum exame de graduação registrado",
            noGradesDescription:
              "Você ainda não registrou nenhum exame de graduação. Comece agora para acompanhar seu progresso!",
            goToGrades: "Acessar a seção",
            seeAllGrades: "Exibir todas as minhas graduações",
            gradeDate: "Data da graduação",
            preparationGrade: "Preparação para Graduação",
            dominante: "Foco principal",
            uv1: "UV1",
            uv2: "UV2",
            uv3Points: "Pontos UV3",
            uv4: "UV4",
            observations: "Observações",
            validated: "Validado",
            notValidated: "Não validado",
            noNextBelt: "Nenhuma faixa seguinte definida.",
          },
          techniquesFavorites: {
            title: "Tokui Waza",
            subtitle: "Minhas Técnicas Favoritas",
            notConnectedTitle: "Suas técnicas favoritas",
            notConnectedDescription:
              "Faça login para ver suas técnicas favoritas e descobrir novas inspirações para sua prática de judô.",
            loginOrRegister: "Entrar ou cadastrar-se",
            noTechniquesTitle: "Nenhuma técnica favorita registrada",
            noTechniquesDescription:
              "Você ainda não selecionou suas técnicas favoritas. Explore as técnicas de judô e adicione as suas preferidas!",
            exploreTechniques: "Explorar técnicas",
            seeAllTechniques: "Ver todas as técnicas",
            family: "Família",
          },
          diaporama: {
            introduction:
              "Aqui está uma seleção de algumas páginas do aplicativo.",
            menu: {
              alt: "Menu",
              caption: "Menu do aplicativo",
            },
            formules: {
              alt: "Planos",
              caption: "Planos gratuitos e pagos",
            },
            evenements: {
              alt: "Eventos",
              caption: "Consultar suas próximas competições ou prazos",
            },
            evenementsPartages: {
              alt: "Eventos compartilhados",
              caption:
                "Possibilidade de consultar eventos compartilhados por outros usuários e copiá-los para sua agenda",
            },
            selectionDept: {
              alt: "Seleção por departamento",
              caption: "Filtro por departamento em um mapa interativo",
            },
            resultats: {
              alt: "Resultados",
              caption: "Registro de seus resultados nos eventos",
            },
            palmares: {
              alt: "Palmarés",
              caption: "Adição de resultados ao seu histórico de competições",
            },
            passages: {
              alt: "Exames de graduação",
              caption: "Gestão de exames de graduação e UV",
            },
            stats: {
              alt: "Estatísticas",
              caption: "Página de estatísticas dos seus combates",
            },
            techniques: {
              alt: "Técnicas",
              caption: "Revisão das técnicas de Judo e Ju-Jitsu",
            },
            kata: {
              alt: "Kata",
              caption: "Revisão dos katas",
            },
            quizz: {
              alt: "Quiz",
              caption: "Quizzes técnicos",
            },
            lexique: {
              alt: "Dicionário",
              caption: "Dicionário Japonês-Português",
            },
            arbitrage: {
              alt: "Arbitragem",
              caption: "Regulamento de arbitragem e comissário esportivo",
            },
            gestionGroupes: {
              alt: "Treinador - Gestão de grupos e judocas",
              caption: "Gestão de grupos e judocas para treinadores",
            },
            qrCode: {
              alt: "Convite por QR code",
              caption: "Convite por QR code para entrar em um grupo",
            },
            enregistrementResultats: {
              alt: "Registro de resultados",
              caption: "Registro dos resultados dos judocas",
            },
            passagesGrades: {
              alt: "Registro de exames de graduação",
              caption: "Registro dos exames de graduação dos judocas",
            },
          },
          formContact: {
            title: "Formulário de Contato",
            intro: "Você tem perguntas ou comentários?",
            prompt: "Não hesite em nos contatar.",
            email: "Seu e-mail",
            name: "Nome e Sobrenome",
            message: "Sua Mensagem",
            sendButton: "Enviar",
            hoverLabel: "Enviar a mensagem",
            successMessage: "Sua mensagem foi enviada com sucesso!",
          },
          profile: {
            title: "Perfil do Usuário",
            changePhoto: "Alterar foto",
            chosenPlan: "Plano escolhido",
            editInfo: "Editar informações",
            selectAvatar: "Selecionar um Avatar",
            editProfile: "Editar Perfil",
            lastName: "Sobrenome",
            firstName: "Nome",
            cancel: "Cancelar",
            save: "Salvar",
            close: "Fechar",
          },
          judokaProfile: {
            title: "Perfil do Judoca",
            changePhoto: "Alterar foto",
            birthDate: "Data de nascimento",
            weight: "Peso",
            license: "Licença",
            club: "Clube",
            country: "País",
            region: "Departamento / Província",
            notSpecified: "Não especificado",
            editInfo: "Editar informações",
            selectAvatar: "Selecionar um Avatar",
            editProfile: "Editar o Perfil do Judoca",
            createProfile: "Criar um Perfil do Judoca",
            lastName: "Sobrenome",
            firstName: "Nome",
            gender: "Gênero",
            selectGender: "Selecione o gênero",
            male: "Masculino",
            female: "Feminino",
            cancel: "Cancelar",
            save: "Salvar",
          },
          judokaCategory: {
            title: "Categorias do Judoca",
            age: "Idade",
            years: "anos",
            notDefined: "Não definido",
            ageCategory: "Categoria de idade",
            weightCategory: "Categoria de peso",
          },
          joinGroup: {
            title: "Entrar em um grupo",
            description:
              "Escaneie um código QR ou insira um link de convite para entrar em um grupo.",
            noRequests: "Você não tem solicitações pendentes.",
            pendingRequest:
              "Sua solicitação para entrar no grupo está aguardando aprovação do treinador.",
            approvedRequest: "Agora você é membro do grupo.",
            rejectedRequest:
              "Sua solicitação para entrar no grupo foi rejeitada pelo treinador.",
            leaveGroup: "Sair do grupo",
            scanQr: "Escanear um código QR",
            scannedQr: "Código QR escaneado:",
            invalidQr: "Nenhum conteúdo válido encontrado no código QR.",
            enterInviteLink: "Insira um link de convite:",
            linkPlaceholder: "https://www.judo-coach-pro.com/join-group/...",
            submit: "Enviar",
            nocamera:
              "Se a câmera não estiver funcionando, insira diretamente o link de convite enviado pelo seu treinador.",
          },
          messagerie: {
            home: "Início",
            yourcount: "Sua Conta",
            messagerie: "Mensagens",
            messagerieTitle: "Suas Mensagens",
            sendAdminMessage: "Enviar uma mensagem ao administrador",
            sendJudokaMessage: "Enviar uma mensagem aos seus judocas",
            sendCoachMessage: "Enviar uma mensagem ao seu treinador",
            receivedMessages: "Mensagens recebidas",
            loading: "Carregando mensagens...",
            noReadMessage: "Marcar como não lida",
            readMessage: "Marcar como lida",
            answer: "Responder",
            delete: "Excluir",
            noMessages: "Nenhuma mensagem para exibir.",
            adminMessage: "Mensagem para o administrador",
            btnAnnuler: "Cancelar",
            btnEnvoyer: "Enviar",
            responseMessage: "Responder à mensagem",
          },
          pricing: {
            title: "Nossos Planos",
            subtitle: "Escolha um plano adequado às suas necessidades.",
            unauthenticated_user: "Usuário não autenticado",
            judo_expert: {
              name: "Judo Expert",
              price: "Grátis",
              features: [
                "Resultados, rankings, graduação de faixa e estatísticas",
                "Acesso a competições e eventos compartilhados",
                "Técnicas, UV2, kata, Questionários, Glossário",
                "Regulamentos, Questionário de arbitragem, Placar",
              ],
            },
            coach: {
              name: "Treinador",
              price: "10 €",
              features: [
                "Judo Expert mais ...",
                "Gerenciamento de um grupo com até 10 membros",
                "Mensagens privadas e seguras com seus membros",
                "Convites e recebimento de respostas para seus eventos",
                "Resultados, Rankings e Estatísticas dos seus membros",
              ],
            },
            coach_pro: {
              name: "Treinador Pro",
              price: "20 €",
              features: [
                "Judo Treinador mais ...",
                "Gerenciamento de 5 grupos, até 50 membros",
              ],
            },
            coach_ultim: {
              name: "Treinador Ultim",
              price: "30 €",
              features: [
                "Judo Treinador Pro mais ...",
                "Gerenciamento de 10 grupos, mais de 50 membros",
              ],
            },
            notifications: {
              success:
                "Transação bem-sucedida! Clique em 'Atualizar Plano' para atualizar.",
              cancel: "Transação cancelada.",
            },
            errors: {
              user_corrupted:
                "Suas informações de usuário parecem estar corrompidas. Por favor, faça login novamente.",
            },
            soutien: {
              title:
                "💙 Apoie o Judo Coach Pro e contribua para o seu crescimento 💙",
              description_1:
                "O aplicativo Judo Coach Pro é um aplicativo web gratuito para judocas, instalável em todos os tipos de dispositivos (Android, iOS, tablets, PC). Se você acha que este aplicativo pode ajudá-lo na sua prática de judô, você pode fazer uma doação.",
              description_2:
                "Sua generosidade me ajudará a desenvolver novas funcionalidades e a criar novos aplicativos relacionados ao Judô. Obrigado antecipadamente. 🙏",
              button: "Doar 5 €",
            },
          },
        },
      },
      nl: {
        translation: {
          menu: {
            open: "MENU",
            close: "SLUITEN",
            home: "Home",
            performanceApp: "Judo Prestatie App",
            profile: "Gebruikersprofiel",
            judokaProfile: "Judoka-profiel",
            joinGroup: "Sluit je aan bij een groep",
            messages: "Berichten",
            messages_form: "Bericht van het formulier",
            dashboard: "Dashboard",
            profilutilisateur: "Gebruikersprofiel",
            pricing: "Plannen en Tarieven",
            results: "Resultaten",
            ranking: "Ranglijst",
            grading: "Gordelpromotie",
            statistics: "Statistieken",
            techniques: "Technieken",
            quiz: "Quiz",
            kata: "Kata",
            lexicon: "Lexicon",
            arbitration: "Arbitrage",
            logout: "Uitloggen",
            login: "Inloggen",
            register: "Registreren",
            account: "Account",
            userProfile: "Gebruikersprofiel",
            pricingPlans: "Plannen en Tarieven",
            agenda: "Agenda",
            yourCompetitions: "Uw Wedstrijden",
            sharedCompetitions: "Gedeelde Wedstrijden",
            performances: "Prestaties",
            techniquesReview: "Technieken Review",
            uv2Review: "UV2 Review",
            katas: "Katas",
            techniquesQuiz: "Technieken Quiz",
            refereeing: "Arbitrage",
            refereeingRules: "Arbitrage Regels",
            csRules: "CS Regels",
            refereeingQuiz: "Arbitrage Quiz",
            scoreboard: "Scorebord",
            yourGroups: "Uw Groepen & Uitnodigingen",
            groupResults: "Resultaten & Prestaties van uw Judoka's",
            groupGrading: "Gordelpromotie van uw Judoka's",
            groupStatistics: "Statistieken",
          },
          homeHero: {
            performancesTitle: "PRESTATIES",
            performancesSubtitle:
              "Resultaten, Ranglijsten, Gordelpromoties en Statistieken",
            performancesDescription:
              "Volg uw prestaties en beoordeel uw voortgang in wedstrijden.",
            techniquesTitle: "TECHNIEKEN",
            techniquesSubtitle: "Bekijk uw technieken, UV2, kata en lexicon",
            techniquesDescription:
              "Leer en verfijn uw technieken met interactieve tools.",
            agendaTitle: "AGENDA",
            agendaSubtitle: "Wedstrijden en gedeelde evenementen",
            agendaDescription: "Organiseer en volg uw wedstrijden eenvoudig.",
            coachTitle: "COACH",
            coachSubtitle: "Groepen, Statistieken en Berichten",
            coachDescription:
              "Beheer uw groepen, controleer hun resultaten en communiceer met uw judoka's.",
            discover: "Ontdekken",
          },
          agenda: {
            title: "Agenda",
            subtitle: "Mijn aankomende wedstrijden en evenementen",
            notConnectedTitle: "Uw aankomende evenementen",
            notConnectedDescription:
              "Log in om uw aankomende evenementen en wedstrijden te bekijken. Als u nog geen account heeft, begin dan met het maken van een profiel om toegang te krijgen tot al deze functies.",
            loginOrRegister: "Inloggen of registreren",
            noEventsTitle: "Geen aankomende evenementen",
            noEventsDescription:
              "Er zijn nog geen evenementen gepland. Kom binnenkort terug om uw aankomende wedstrijden te zien!",
            goToEvents: "Ga naar de evenementensectie",
            myNextEvents: "Mijn aankomende evenementen",
            eventDetails: "Details bekijken",
            close: "Sluiten",
            seeAllEvents: "Alle evenementen bekijken",
          },
          results: {
            title: "Resultaten",
            subtitle: "Mijn laatste wedstrijdresultaten",
            notConnectedTitle: "Uw wedstrijdresultaten",
            notConnectedDescription:
              "Log in om uw laatste resultaten, ranglijsten, observaties en meer te bekijken. Als u nog geen account heeft, begin dan met het maken van een profiel om toegang te krijgen tot al deze functies.",
            loginOrRegister: "Inloggen of registreren",
            noResultsTitle: "Geen resultaten beschikbaar",
            noResultsDescription:
              "U kunt nu uw wedstrijdresultaten registreren om ze hier gemakkelijk te bekijken.",
            goToResults: "Ga naar de resultaatsectie",
            table: {
              date: "Datum",
              title: "Titel",
              ranking: "Ranglijst",
              results: "Resultaten",
              observations: "Observaties",
            },
            seeAllResults: "Toon al mijn resultaten",
          },
          palmares: {
            title: "Ranglijsten",
            subtitle: "Mijn laatste ranglijsten",
            notConnectedTitle: "Uw laatste ranglijsten",
            notConnectedDescription:
              "Log in om uw laatste wedstrijdprestaties te registreren en te ontdekken. Bekijk uw ranglijsten en deel uw prestaties!",
            loginOrRegister: "Inloggen of registreren",
            noPalmaresTitle: "Geen ranglijsten beschikbaar",
            noPalmaresDescription:
              "U heeft nog geen resultaten geregistreerd in uw ranglijsten. Neem deel aan wedstrijden en volg uw prestaties!",
            goToPalmares: "Ga naar de ranglijstsectie",
            seeAllPalmares: "Bekijk ranglijsten",
          },
          passageGrade: {
            title: "Gordel Examens",
            subtitle: "Mijn laatste gordel examens",
            notConnectedTitle: "Uw gordel examens",
            notConnectedDescription:
              "Log in om uw laatste gordel examens te bekijken en uw voortgang te volgen.",
            loginOrRegister: "Inloggen of Registreren",
            noGradesTitle: "Geen gordel examen geregistreerd",
            noGradesDescription:
              "U heeft nog geen gordel examens geregistreerd. Begin nu om uw voortgang te volgen!",
            goToGrades: "Ga naar de sectie",
            seeAllGrades: "Bekijk al mijn gordel examens",
            gradeDate: "Examendatum",
            preparationGrade: "Voorbereiding op examen",
            dominante: "Hoofdfocus",
            uv1: "UV1",
            uv2: "UV2",
            uv3Points: "UV3 punten",
            uv4: "UV4",
            observations: "Opmerkingen",
            validated: "Goedgekeurd",
            notValidated: "Niet goedgekeurd",
            noNextBelt: "Geen volgende gordel gedefinieerd.",
          },
          techniquesFavorites: {
            title: "Tokui Waza",
            subtitle: "Mijn favoriete technieken",
            notConnectedTitle: "Uw favoriete technieken",
            notConnectedDescription:
              "Log in om uw favoriete technieken te bekijken en nieuwe inspiratie op te doen voor uw judopraktijk.",
            loginOrRegister: "Inloggen of registreren",
            noTechniquesTitle: "Geen favoriete technieken opgeslagen",
            noTechniquesDescription:
              "U heeft nog geen favoriete technieken geselecteerd. Ontdek de judotechnieken en voeg uw favorieten toe!",
            exploreTechniques: "Technieken ontdekken",
            seeAllTechniques: "Alle technieken bekijken",
            family: "Familie",
          },
          diaporama: {
            introduction:
              "Hier is een selectie van enkele pagina's van de applicatie.",
            menu: {
              alt: "Menu",
              caption: "Menu van de applicatie",
            },
            formules: {
              alt: "Abonnementen",
              caption: "Gratis en betaalde abonnementen",
            },
            evenements: {
              alt: "Evenementen",
              caption: "Bekijk je komende competities of deadlines",
            },
            evenementsPartages: {
              alt: "Gedeelde evenementen",
              caption:
                "Mogelijkheid om gedeelde evenementen van andere gebruikers te bekijken en deze in je agenda op te slaan",
            },
            selectionDept: {
              alt: "Selectie per regio",
              caption: "Filteren per regio op een interactieve kaart",
            },
            resultats: {
              alt: "Resultaten",
              caption: "Registratie van je resultaten in evenementen",
            },
            palmares: {
              alt: "Palmares",
              caption: "Toevoegen van resultaten aan je palmares",
            },
            passages: {
              alt: "Graadexamens",
              caption: "Beheer van graadexamens en UV",
            },
            stats: {
              alt: "Statistieken",
              caption: "Statistiekenpagina van je wedstrijden",
            },
            techniques: {
              alt: "Technieken",
              caption: "Overzicht van Judo- en Ju-Jitsu-technieken",
            },
            kata: {
              alt: "Kata",
              caption: "Overzicht van kata's",
            },
            quizz: {
              alt: "Quiz",
              caption: "Technische quizzen",
            },
            lexique: {
              alt: "Woordenlijst",
              caption: "Japans-Nederlandse woordenlijst",
            },
            arbitrage: {
              alt: "Scheidsrechter",
              caption: "Regels voor scheidsrechters en wedstrijdcommissarissen",
            },
            gestionGroupes: {
              alt: "Coach - Beheer van groepen en judoka's",
              caption: "Beheer van groepen en judoka's voor coaches",
            },
            qrCode: {
              alt: "Uitnodiging via QR-code",
              caption: "Uitnodiging via QR-code om deel te nemen aan een groep",
            },
            enregistrementResultats: {
              alt: "Registratie van resultaten",
              caption: "Registratie van de resultaten van de judoka's",
            },
            passagesGrades: {
              alt: "Registratie van graadexamens",
              caption: "Registratie van de graadexamens van de judoka's",
            },
          },
          formContact: {
            title: "Contactformulier",
            intro: "Heeft u vragen of opmerkingen?",
            prompt: "Aarzel niet om contact met ons op te nemen.",
            email: "Uw e-mail",
            name: "Voor- en achternaam",
            message: "Uw Bericht",
            sendButton: "Verzenden",
            hoverLabel: "Bericht verzenden",
            successMessage: "Uw bericht is succesvol verzonden!",
          },
          profile: {
            title: "Gebruikersprofiel",
            changePhoto: "Foto wijzigen",
            chosenPlan: "Gekozen Plan",
            editInfo: "Informatie bewerken",
            selectAvatar: "Selecteer een Avatar",
            editProfile: "Profiel bewerken",
            lastName: "Achternaam",
            firstName: "Voornaam",
            cancel: "Annuleren",
            save: "Opslaan",
            close: "Sluiten",
          },
          judokaProfile: {
            title: "Judoka Profiel",
            changePhoto: "Foto wijzigen",
            birthDate: "Geboortedatum",
            weight: "Gewicht",
            license: "Licentie",
            club: "Club",
            country: "Land",
            region: "Regio / Provincie",
            notSpecified: "Niet gespecificeerd",
            editInfo: "Informatie bewerken",
            selectAvatar: "Selecteer een Avatar",
            editProfile: "Judoka-profiel bewerken",
            createProfile: "Judoka-profiel aanmaken",
            lastName: "Achternaam",
            firstName: "Voornaam",
            gender: "Geslacht",
            selectGender: "Selecteer geslacht",
            male: "Mannelijk",
            female: "Vrouwelijk",
            cancel: "Annuleren",
            save: "Opslaan",
          },
          judokaCategory: {
            title: "Categorieën van de Judoka",
            age: "Leeftijd",
            years: "jaar",
            notDefined: "Niet gedefinieerd",
            ageCategory: "Leeftijdscategorie",
            weightCategory: "Gewichtscategorie",
          },
          joinGroup: {
            title: "Lid worden van een groep",
            description:
              "Scan een QR-code of voer een uitnodigingslink in om lid te worden van een groep.",
            noRequests: "Je hebt geen openstaande verzoeken.",
            pendingRequest:
              "Je verzoek om lid te worden van de groep wacht op goedkeuring van de coach.",
            approvedRequest: "Je bent nu lid van de groep.",
            rejectedRequest:
              "Je verzoek om lid te worden van de groep is afgewezen door de coach.",
            leaveGroup: "Groep verlaten",
            scanQr: "QR-code scannen",
            scannedQr: "Gesproken QR-code:",
            invalidQr: "Geen geldige inhoud gevonden in de QR-code.",
            enterInviteLink: "Voer een uitnodigingslink in:",
            linkPlaceholder: "https://www.judo-coach-pro.com/join-group/...",
            submit: "Verzenden",
            nocamera:
              "Als de camera niet werkt, voer dan direct de uitnodigingslink in die uw coach heeft gestuurd.",
          },
          messagerie: {
            home: "Startpagina",
            yourcount: "Jouw Account",
            messagerie: "Berichten",
            messagerieTitle: "Jouw Berichten",
            sendAdminMessage: "Stuur een bericht naar de beheerder",
            sendJudokaMessage: "Stuur een bericht naar je judoka's",
            sendCoachMessage: "Stuur een bericht naar je coach",
            receivedMessages: "Ontvangen berichten",
            loading: "Berichten laden...",
            noReadMessage: "Markeren als ongelezen",
            readMessage: "Markeren als gelezen",
            answer: "Antwoorden",
            delete: "Verwijderen",
            noMessages: "Geen berichten om weer te geven.",
            adminMessage: "Bericht voor de beheerder",
            btnAnnuler: "Annuleren",
            btnEnvoyer: "Verzenden",
            responseMessage: "Antwoorden op het bericht",
          },
          pricing: {
            title: "Onze Pakketten",
            subtitle: "Kies een pakket dat bij je past.",
            unauthenticated_user: "Niet-geauthenticeerde gebruiker",
            judo_expert: {
              name: "Judo Expert",
              price: "Gratis",
              features: [
                "Resultaten, ranglijsten, gordelpromoties en statistieken",
                "Toegang tot gedeelde competities en evenementen",
                "Technieken, UV2, kata, Quizzen, Woordenlijst",
                "Reglement, Scheidsrechter Quiz, Scorebord",
              ],
            },
            coach: {
              name: "Coach",
              price: "10 €",
              features: [
                "Judo Expert plus ...",
                "Beheer van een groep met maximaal 10 leden",
                "Privé en veilige berichten met je leden",
                "Uitnodigingen en ontvangst van antwoorden op je evenementen",
                "Resultaten, Ranglijsten en Statistieken van je leden",
              ],
            },
            coach_pro: {
              name: "Coach Pro",
              price: "20 €",
              features: [
                "Judo Coach plus ...",
                "Beheer van 5 groepen, tot 50 leden",
              ],
            },
            coach_ultim: {
              name: "Coach Ultim",
              price: "30 €",
              features: [
                "Judo Coach Pro plus ...",
                "Beheer van 10 groepen, meer dan 50 leden",
              ],
            },
            notifications: {
              success:
                "Transactie geslaagd! Klik op 'Plan bijwerken' om te updaten.",
              cancel: "Transactie geannuleerd.",
            },
            errors: {
              user_corrupted:
                "Uw gebruikersgegevens lijken beschadigd. Log alstublieft opnieuw in.",
            },
            soutien: {
              title:
                "💙 Steun Judo Coach Pro en draag bij aan de groei ervan 💙",
              description_1:
                "De Judo Coach Pro-app is een gratis webapplicatie voor judoka's, die op alle soorten apparaten kan worden geïnstalleerd (Android, iOS, tablets, PC). Als je denkt dat deze app je kan helpen bij je judo-training, kun je een donatie doen.",
              description_2:
                "Jouw vrijgevigheid zal mij helpen nieuwe functies te ontwikkelen en nieuwe toepassingen te maken die verband houden met judo. Alvast bedankt. 🙏",
              button: "Doneer 5 €",
            },
          },
        },
      },
    },
    fallbackLng: "fr", // Langue par défaut si aucune n'est détectée
    interpolation: {
      escapeValue: false, // React se charge déjà de l'échappement
    },
  });

export default i18n;
